import React, { Fragment, useContext, useRef, useState } from "react";
import moment from "moment";
import AppConfig from "../../config/AppConfig";
import {
  alertMessage,
  checkNegitive,
  ellipseText,
  isEmpty,
} from "../../common/Common";
import I18n from "../../common/I18n";
import {
  Popover,
  Link,
  Tooltip,
  Icon,
  Row,
  Col,
  Popconfirm,
  InputNumber,
  Input,
  Tag,
  Typography,
  Table,
  Space,
  Button
} from "../../common/UIComponents";
// import { retrieveAddress, retrieveOrderValue } from "../../helpers/orders";
import { bothWeightUnits, checkAccessExistance, checkServiceExistance, convertToKilograms, convertToPounds, convertToUnitsWithBothLabels, formatFullName, formatLocValues, formatPickupDeliveryCompanyNames, getFormattedWeight, getWeightUnits } from "../../helpers/common";
import TypeOfOrder from "../orders/TypeOfOrder";
import AgentTenderIndicator from "../orders/tenders/AgentTenderIndicator";
import ValidateLocationErr from "../orders/ValidateLocationErr";
import ConsigneeDetails from "../common/ConsigneeDetails";
import OrderFieldDisplay from "../orders/OrderFieldDisplay";
import { VehicleImageData } from "../../common/VehicleImageData";
import { formatWeight, hasQuickDispatchAssignableLegs, renderColumnValue, retrieveAddress, retrieveOrderValue } from "../../helpers/orders";
import { AppointmentDisplay, WindowTimeDisplay, ZonesDisplay, colorStatusStyle, colorTagToolTip, fetchLocAddress, getAddress, getAddressForPreplanCol, getBillingAddress, getContrastColor, renderOrderNumType, renderOrderNumTypePreplan } from "../dispatches/helpers";
import { OrgContext } from "../../context/OrgContext";
import OrderAppointments from "../orders/OrderAppointments";
import EditIcon from "./EditIcon";
import SettingIcon from "./SettingIcon";
import DeleteIcon from "./DeleteIcon";
import userStore from "../../stores/UserStore";
import Copyable from "./Copyable";
import { returnStatement } from "@babel/types";
import OrderBillingDetails from "../billing/OrderBillingDetails";
import CopyableContent from "./CopyableContent";
import DisplayTime from "./DisplayTime";
import EditDriverDetails from "./EditDriverDetails";
import BranchesIcon from "./BranchesIcon";
import FormIcon from "./FormIcon";
import PreplanOrderAccessorial from "../orders/PreplanOrderAccessorial";
import PreplanOrderNotes from "../orders/PreplanOrderNotes";
import CustomerOrderDetails from "../orders/CustomerOrderDetails";
import OrderAttachments from "../orders/OrderAttachments";
import AddressInfo from "./AddressInfo";
import EstimateData from "../../common/EstimateData";
import ManualBolViewer from "../../common/ManualBolViewer";
const _ = require('lodash');
import manualBol from "../../../assets/images/manualColor.png"
import { AssignDriverIcon, AssignIcon, BillingSettingsIcon, BolIcon, EditIconSvg, EditRearrangableIcon, OsdIcon, HazmatIndicationImg, RouteIcon, SettingIconSvg, SurveyForm, RebillIcon, CustomsOfficerIcon, TenderIcon } from "../../common/CustomIcon";
import LegCell from "../preplan_management/LegCell";
import LegHeaderCell from "../preplan_management/LegHeaderCell";
import RowLegCheckboxCell from "../preplan_management/RowLegCheckboxCell";
import RowLegHeaderCheckboxCell from "../preplan_management/RowLegHeaderCheckboxCell";
import OrderQuantity from "../preplan/OrderQuantity";
import lock from "../../../assets/images/lock_blue.png";
import { AccountUnitsContext } from "../../context/AccountUnitsContext";
import { RevertIcon, RevertIconFilled, OrgLevelAccIcon, AccLevelAccIcon, MasterLevelAccIcon } from "../../common/CustomIcon";
import Button_v2 from "../../stories/components/Button_v2";
import AssignOrders from "../orders/AssignOrders";
import { OrderConfigContext } from "../../context/OrderConfigContext";
import { getDispatchColorObject } from "../orders/helpers";
import HazmatImg from "../../stories/components/HazmatImg";
import DeleteActionPopover from "../configurations/accessorials/DeleteActionPopover";

function displayTransferAddress (order,key) {
  if(key === 'PREPLAN'){
    const locations = order?.locations;
    const pickupLocation = _.find(locations, { type_of_loc: 'PICKUP' });
    const deliveryLocation = _.find(locations, { type_of_loc: 'DELIVERY' });
  
    const formatAddress = (location) => {
      const address = location?.l_address;
      if (!address?.address_line1 && !address?.city && !address?.state && !address?.zipcode) {
        return 'NA';
      }
      return `${address?.address_line1 ?? ''}, ${address?.city ?? ''}, ${address?.state ?? ''} ${address?.zipcode ?? ''}`.trim();
    };
  
    if (pickupLocation && deliveryLocation) {
      const pickupAddress = formatAddress(pickupLocation);
      const deliveryAddress = formatAddress(deliveryLocation);
      return `${pickupAddress} -> ${deliveryAddress}`;
    } else {
      const location = locations?.[0];
      const address = formatAddress(location);
      return `${address}`;
    }
  }else {
    const origin  = _.get(order, 'origin', {});
    const destination = _.get(order, 'destination', {});

    const formatAddress = (location) => {
      if (!location?.address_line1 && !location?.city && !location?.state && !location?.zipcode) {
        return 'NA';
      }
      return `${location?.address_line1 ?? ''}, ${location?.city ?? ''}, ${location?.state ?? ''} ${location?.zipcode ?? ''}`.trim();
    };

    if (origin && destination) {
      const pickupAddress = formatAddress(origin);
      const deliveryAddress = formatAddress(destination);
      return `${pickupAddress} -> ${deliveryAddress}`;
    }else{
      const address = order?.cs_location;
      const formattedAddress = formatAddress(address);
      return `${formattedAddress}`;
    }
  }
}

const getPreplanLocationByType = (data, locationType) =>
  _.find(_.get(data, "locations", []), { type_of_loc: locationType });

const getDragLocationIdsForType = (data, dragType = "ORDER") => {
  const pickupId = getPreplanLocationByType(data, "PICKUP")?.id;
  const deliveryId = getPreplanLocationByType(data, "DELIVERY")?.id;

  if (dragType === "PICKUP") return _.compact([pickupId]);
  if (dragType === "DELIVERY") return _.compact([deliveryId]);

  return _.compact([pickupId, deliveryId]);
};

const setActiveRowDragMeta = (data, dragType = "ORDER") => {
  if (!data?.id) return;

  data.dragged_item_id = dragType === "ORDER" ? data.id : `${data.id}::${dragType}`;
  data.dragged_item_source_id =
    dragType === "ORDER" ? data.customer_order_number : `${data.customer_order_number}::${dragType}`;
  data.dragged_location_ids = getDragLocationIdsForType(data, dragType);
};

const getAgGridRowDataForDrag = (params) =>
  params?.node?.data || params?.rowNode?.data || params?.data || null;

const applyRowDragMetaToLiveRow = (params, dragType) => {
  const rowData = getAgGridRowDataForDrag(params);
  if (rowData) setActiveRowDragMeta(rowData, dragType);
  return rowData;
};

const getLegDisplayValue = (location, fallbackLabel) => (
  location?.type_of_loc ||
  fallbackLabel
);

const setDragMetaAndGetText = (params, dragType = "ORDER") => {
  applyRowDragMetaToLiveRow(params, dragType);
  return (
    params?.defaultTextValue ||
    params?.rowNode?.data?.customer_order_number ||
    params?.data?.customer_order_number ||
    ""
  );
};

const ellipsisStyle = {
  whiteSpace: 'nowrap', 
  overflow: 'hidden',   
  textOverflow: 'ellipsis',
};
const setAddress = (data, type) => {
  const pickUpdata = data?.pickup_location_details
    ? data.pickup_location_details.l_address
    : {}
  const pickUpAddress = (
    <Popover
      title={I18n.t('general.pickup_address')}
      content={<AddressInfo address={pickUpdata} />}
      overlayStyle={{ width: 200 }}
      // getPopupContainer={(triggerNode) => triggerNode.parentNode}
    >
      {pickUpdata && pickUpdata.city ? `${pickUpdata.city}` : 'NA'}
    </Popover>
  )
  const deliveryData = data?.delivery_location_details
    ? data.delivery_location_details.l_address
    : {}
  const dropAddress = (
    <Popover
      title={I18n.t('general.delivery_address')}
      content={<AddressInfo address={deliveryData} />}
      overlayStyle={{ width: 200 }}
      // getPopupContainer={(triggerNode) => triggerNode.parentNode}
    >
      {deliveryData && deliveryData.city ? `${deliveryData.city}` : 'NA'}
    </Popover>
  )
  if (type === 'origin') {
    return pickUpAddress
  }
  return dropAddress
}




const CustomInputNumberEditor = ({ value, onValueChange, rowIndex, colKey, onKeyDown, placeholder, decimalPoints }) => {
  const inputRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault(); // Prevent default Tab behavior
      
      // Move focus to the next input field
      const nextInput = inputRef.current.nextElementSibling;
      if (nextInput) {
        nextInput.focus();
      }
    } else {
      onKeyDown(e);
    }
  };

  return (
    <InputNumber
      ref={inputRef}
      value={value}
      onChange={onValueChange}
      onKeyDown={handleKeyDown}
      size="small"
      placeholder={placeholder}
      min={0}
      precision={decimalPoints}
       //   <InputNumber
  //     value={params.data.charge}
  //     size="small"
  //     className="fontSize12"
  //     // onChange={(e) =>
  //     //   onChange(params.rowIndex, 'charge', e)
  //     // }
  //     onChange={(e) => {
  //       params.setValue(e); // Update the value in the grid
  //       params.node.setDataValue(params.colDef.field, e); // Update the data
  //     }}
  //     placeholder={I18n.t('reports.chargable')}
  //     min={0}
  //     precision={decimalPoints}
  //     style={{ width: 100 }}
    />
  );
};

export default CustomInputNumberEditor;


function TrackLinkRenderer({ data }) {
  const organization_id = userStore.getStateValue("selectedOrg");
  const trackLink = `${window.location.origin}/drivers_tracking/track_driver?organization_id=${userStore.getStateValue(
    "selectedOrg"
  )}&location_code=${data.location_code}`;

  return (
    <Copyable
      text={trackLink}
      tooltipText={I18n.t("location.track_link")}
      color="#1890ff"
      showTooltip
    >
      <Icon type="copy" style={{ cursor: 'pointer' }} />
    </Copyable>
  );
}


export const checkboxColumn = {
  key: "checkbox",
  field: "0",
  width: 50,
  checkboxSelection: true,
  headerCheckboxSelection: true,
  filter: false,
  sortable: false,
  floatingFilter:false,
  resizable: false,
  pinned: "left",
  suppressMenu: true,
  suppressMovable: true,
  suppressNavigable: true,
  suppressResize: true,
  headerCheckboxSelectionFilteredOnly:true,
  showDisabledCheckboxes: true,
};

// Checkbox column
export const dvCheckboxColumn = {
  field: "0", 
  key:"checkbox",
  width: 50,
  checkboxSelection: (params) => {
    return params.node.data.status === "PENDING"
  },
  showDisabledCheckboxes: false,
  // cellRenderer: (params) => {
  //   if (params.node.data.status !== "PENDING") { // Renderiza um checkbox desabilitado nas linhas isEnabled=false
  //       return `<input type="checkbox" disabled />`;
  //   }
  // },
  headerCheckboxSelection: true,
  filter: false,
  sortable: false,
  resizable: false,
  pinned: "left",
  suppressMenu: true,
  suppressMovable: true,
  suppressNavigable: true,
  suppressResize: true,
  headerCheckboxSelectionFilteredOnly:true,
  showDisabledCheckboxes: true,
  floatingFilter: false,
};

// Reference 1 column
export const reference1Column = {
  headerName: 'Reference 1',
  field: 'reference_1',
  isVisible : true,
  cellRenderer: (params) => <OrderFieldDisplay data={ params.data } toDisplay="reference_1" charsToLimit={ null } />,
  width: 140,
};

// Reference 2 column
export const reference2Column = {
  headerName: 'Reference 2',
  field: 'reference_2',
  isVisible : true,
  cellRenderer: (params) => <OrderFieldDisplay data={ params.data } toDisplay="reference_2" charsToLimit={ null } />,
  width: 140,
};

const getReferenceColumn = (showTriggerEdit, handleEditOrder, refreshCallback, refName, showEditIcon) => {
  const reference1Column = {
    headerName: _.capitalize(_.upperCase(refName)),
    field: refName,
    isVisible: true,
    cellRenderer: (params) => <OrderFieldDisplay data={params.data} toDisplay={refName} showEditIcon={showEditIcon} showTriggerEdit={showTriggerEdit} editClick={() => handleEditOrder(params.data.id)} refreshCallback={refreshCallback} charsToLimit={null} showOrderDetailsByReference={true} />,
    width: 140,
  };
  return reference1Column;
};

const EndUserTitle = () => {
  const { endUserName } = useContext(OrgContext);
  return (
    <div>
      <span className="endUserTitle">{ endUserName }</span>
    </div>
  );
};


// turn into function 
const getCustomerNameColumn = () => {
  const { endUserName } = useContext(OrgContext);
  return {
    headerName: endUserName,
    field: 'consignee',
    isVisible : true,
    valueGetter: (params) => {
      const data = params.data;
      if (["T", "LH"].includes(data.type_of_order)) {
        const originConsignee = formatFullName(data.origin, "customer_first_name", "customer_last_name", "N/A"); //_.get(data.origin, 'customer_first_name', 'N/A');
        const destinationConsignee = formatFullName(data.destination, 'customer_first_name',"customer_last_name", "N/A"); // _.get(data.destination, 'customer_first_name', 'N/A');
        return `P: ${originConsignee} - D: ${destinationConsignee}`;
      } else {
        return formatFullName(data, 'customer_first_name',"customer_last_name", "N/A"); // data.customer_first_name || 'NA';
      }
    },
    sortable: true,
    cellRenderer: (params) => {
      const record = params.data;
      const originConsignee = formatFullName(record.origin, "customer_first_name", "customer_last_name", "N/A") //_.get(record.origin, 'customer_first_name', 'N/A');
      const destinationConsignee = formatFullName(record.destination, "customer_first_name", "customer_last_name", "N/A") //_.get(record.destination, 'customer_first_name', 'N/A');
      const fullName = formatFullName(record, "customer_first_name", "customer_last_name", "N/A")
      const displayName = ["T", "LH", "MS"].includes(record.type_of_order)
        ? `P: ${originConsignee} - D: ${destinationConsignee}`
        : fullName;
      return (
        <div className="ellipsis-text">
        <Popover title={ I18n.t('general.customer_details') } content={ <ConsigneeDetails record={ params.data } key={ `consigneeDetails${params.data.id}` } /> }>
        {displayName}
        </Popover>
      </div>
      )
    },
    cellStyle: {
      textAlign: 'left',
    },
  };
}



const getCustomerNameColumnForPreplan = () => {
  const { endUserName } = useContext(OrgContext);
  return {
    headerName: endUserName,
    field: 'consignee',
    isVisible : true,
    valueGetter: (params) => params.data.customer_first_name || '',
    sortable: true,
    cellRenderer: (params) => {
      if (["T", "LH"].includes(params.data.type_of_order)) {
        const locationNames = params.data.locations.map((loc) => {
          const name = formatFullName(loc);
          return `${loc.type_of_loc === 'PICKUP' ? 'P: ' : 'D: '}${name}`;
        }).join(' - ');
        return (
          <Row>
            <Col>
              { locationNames }
            </Col>
          </Row>
        );
      }
      const name = formatFullName(params.data, "customer_first_name", "customer_last_name");
      return (
        <div>
          <Popover title={ I18n.t('general.customer_details') } content={ <ConsigneeDetails record={ params.data } key={ `consigneeDetails${params.data.id}` } /> }>
            { isEmpty(name) ? '' : name }
          </Popover>
        </div>
      );
    },
    cellStyle: {
      textAlign: 'left',
    },
  };
}


// originFilter.js
export const originFilter = (data, showTerminal = false) => {
  const sourcePoint =
    data?.origin && Object.keys(data.origin).length !== 0
      ? data.origin
      : data.warehouse_address;

  const destinationPoint =
    data?.destination && Object.keys(data.destination).length !== 0
      ? data.destination
      : data.customer_address;

  if (showTerminal) {
    const originText = data?.origin_terminal || sourcePoint?.city || 'NA';
    const destinationText = data?.destination_terminal || destinationPoint?.city || 'NA';
    return `${originText} - ${destinationText}`.toLowerCase();
  }

  return `${sourcePoint?.city || 'NA'} - ${destinationPoint?.city || 'NA'}`.toLowerCase();
};

export const quoteOriginFilter = (data) => {
  const sourcePoint =
    data?.pickup_location_details?.l_address && Object.keys(data.pickup_location_details.l_address).length !== 0
      ? data.pickup_location_details.l_address
      : data.wh_location_details?.l_address;

  const destinationPoint =
    data?.delivery_location_details?.l_address && Object.keys(data.delivery_location_details.l_address).length !== 0
      ? data.delivery_location_details.l_address
      : data.customer_address;

  return `${sourcePoint?.city || 'NA'} - ${destinationPoint?.city || 'NA'}`.toLowerCase();
};




// Origin -> Destination column
export const originDestinationColumn = (organizationSettings = {}) => {
  const showTerminal = organizationSettings?.show_terminal_quotes_orders == "true" ?? false;

  const renderLocation = (data, type) => {
    if (showTerminal) {
      const sourcePoint =
        data?.origin && Object.keys(data.origin).length !== 0
          ? data.origin
          : data.warehouse_address;
      const destinationPoint =
        data?.destination && Object.keys(data.destination).length !== 0
          ? data.destination
          : data.customer_address;

      const titleKey = type === 'origin' ? 'general.origin_location' : 'general.destination_location';
      const defaultTitle = type === 'origin' ? 'general.warehouse_address' : 'general.customer_address';
      const addressData = type === 'origin' ? sourcePoint : destinationPoint;

      return (
        <Popover
          title={addressData?.city ? I18n.t(titleKey) : I18n.t(defaultTitle)}
          content={<AddressInfo address={addressData} />}
          overlayStyle={{ width: 200 }}
        >
          {data?.[`${type}_terminal`] || "NA"}
        </Popover>)
    } else {
      return fetchLocAddress(data, type);
    }
  };

  return {
    headerName: 'Origin -> Destination',
    field: 'orgin_destination',
    isVisible: true,
    valueGetter: (params) => originFilter(params.data, showTerminal), // pass the flag through
    cellRenderer: (params) => (
      <div style={{ display: 'flex' }}>
        <div className="ellipsis-text">{renderLocation(params.data, 'origin')}</div>
        <span>&nbsp;{' - '}&nbsp;</span>
        <div className="ellipsis-text">{renderLocation(params.data, 'destination')}</div>
      </div>
    ),
    width: 200,
  };
};



// Origin -> Destination column Quotes
const QuotesOriginDestinationColumn = {
  headerName: 'Origin -> Destination',
  field: 'city',
  isVisible: true,
  valueGetter: (params) => quoteOriginFilter(params.data),

  cellRenderer: (params) => {
    return (
      <div style={{ display: 'flex' }}>
        <div>{setAddress(params.data, 'origin')}</div>
        <span>&nbsp;{' - '}&nbsp;</span>
        <div>{setAddress(params.data, 'destination')}</div>
      </div>
    );
  },

  // width: 200,
};

// City column
export const cityColumn = (incomingVal = null) => ({
  headerName: 'City',
  field: 'cities',
  isVisible : true,
  floatingFilterComponentParams: { suppressFilterButton: true },
  valueGetter: (params) => {
    if (incomingVal === "preplan") {
      if (["T", "LH"].includes(params.data.type_of_order)) {
        const locations = _.get(params, 'data.locations', []);
        const pickup = locations.find(location => location.type_of_loc === "PICKUP");
        const delivery = locations.find(location => location.type_of_loc === "DELIVERY");
        const pickupCity = pickup ? pickup.l_address.city.toLowerCase() : "";
        const dropCity = delivery ? delivery.l_address.city.toLowerCase() : "";
        return { pickupCity, dropCity };
      } else {
        return _.get(params, 'data.customer_city', '');
      }
    } else {
      return _.get(params, 'data.customer_address.city', '');
    }
  },
  cellRenderer: (params) => {
    const { pickupCity = '', dropCity = '' } = params.value || {};
    const tootlTipDelay = AppConfig.tooltipDelay;
    // Determine if we're dealing with a preplan case
    if (incomingVal === "preplan" && ["T", "LH"].includes(params.data.type_of_order)) {
      return (
        <>
          {pickupCity.length > 0 && (
            <Tooltip
              title={{ P: pickupCity }}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              placement="topRight"
              mouseEnterDelay={tootlTipDelay}
            >
              {`P: ${pickupCity}`}
            </Tooltip>
          )}
          {pickupCity.length > 0 && dropCity.length > 0 && <>&nbsp;{' - '}&nbsp;</>}
          {dropCity.length > 0 && (
            <Tooltip
              title={{ D: dropCity }}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              placement="topRight"
              mouseEnterDelay={tootlTipDelay}
            >
              {`D: ${dropCity}`}
            </Tooltip>
          )}
        </>
      );
    } else {
      // For non-preplan or non T/LH orders, display customer city
      const customerCity = params.value;
      return (
        <Tooltip
          title={customerCity}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          placement="topRight"
          mouseEnterDelay={tootlTipDelay}
        >
          {customerCity}
        </Tooltip>
      );
    }
  },
  cellStyle: {
    textAlign: 'left',
  },
});

// Warehouse column
export const warehouseColumn = {
  headerName: I18n.t('general.warehouse'),
  field: 'warehouse',
  isVisible : true,
  sortable:false,
  valueGetter: (params) => _.get(params, 'data.warehouse_address.city', ''),
  cellStyle: {
    textAlign: 'left',
  },
};

const priorityColumn = {
  headerName: 'Priority',
  field: 'priority',
  sortable: true,
  filter: false,
  isVisible: true,
  width:50,
  cellRenderer: (params) => {
    if (!params.data.priority || params.data.priority === null || params.data.priority === false) {
      return (
      <div className="ellipsis-text">
      No </div>)
    }
    return (
      <div className="ellipsis-text">
      <span>
        Yes &nbsp; <Icon type="flag" style={{ color: 'red', fontSize: '15px' }} />
      </span>
      </div>
    );
  },
};

// Routing column
export const routingColumn = {
  headerName: 'Routing',
  field: 'routing',
  sortable: true,
  floatingFilterComponentParams: { suppressFilterButton: true },
  isVisible : true,
  valueGetter: (params) => params.data.routing || '',
};

export const sourceColumn = {
  headerName: 'Source',
  field: 'source',
  sortable: true,
  floatingFilterComponentParams: { suppressFilterButton: true },
  isVisible : true,
  valueGetter: (params) => AppConfig.orderInboundSource[params.data.source] || '',
  cellRenderer: (params) => AppConfig.orderInboundSource[params.data.source] || '',
  width:100,
};


export const itNumberColumn = {
  headerName: 'IT Number',
  field: 'it_number',
  sortable: true,
  floatingFilterComponentParams: { suppressFilterButton: true },
  isVisible : true,
  valueGetter: (params) => params.data.it_number || '',
};


/*const CreatedByColumn = {
  headerName: 'Created By',
  field: 'created_by',
  sortable: true,
  isVisible : true,
  valueGetter: (params) => params.data.created_by || '',
};*/
const CreatedByColumn = {
  headerName: 'Created By',
  field: 'created_by',
  sortable: true,
  isVisible: true,
  valueGetter: (params) => params.data.created_by || '',
  cellRenderer: (params) => {
    const text = params.value || '';
    return (
      <div className="ellipsis-text">
        {text}
      </div>
    );
  }
};
const createdDateColumn = {
  headerName: 'Created Date',
  field: 'created_date',
  isVisible: true,
  sortable: true,
  valueGetter: (params) => params?.data?.created_at || '',
  cellRenderer: (params) => (
    <div>
      {params.data.created_at ?  
        <DisplayTime
        dateTimeString={params.data.created_at}
        timeFormat={AppConfig.dateFormat}
        displayWithDate={true}
        timeZoneId={params.data.timeZoneId}
        isUTC={false}
        />: ''}
    </div>
  )
};

const approvedDateColumn = {
  headerName: 'Approved Date',
  field: 'approved_date',
  isVisible: true,
  sortable: true,
  valueGetter: (params) => params?.data?.approved_at || '',
  cellRenderer: (params) => (
    <div>
      {params.data.approved_at ? 
      <DisplayTime
        dateTimeString={params.data.approved_at}
        timeFormat={AppConfig.dateFormat}
        displayWithDate={true}
        timeZoneId={params.data.timeZoneId}
        isUTC={false}
        />: ''}
    </div>
  )
};

const receivedDateColumn = {
  headerName: 'Received Date',
  field: 'received_at',
  isVisible: true,
  sortable: true,
  valueGetter: (params) => params?.data?.received_at || '',
  cellRenderer: (params) => (
    <div>
      {params.data.received_at ?
        <DisplayTime
          dateTimeString={params.data.received_at}
          timeFormat={AppConfig.dateTimeFormat}
          displayWithDate={true}
          timeZoneId={params.data.timeZoneId}
          isUTC={false}
        /> : 'N/A'}
    </div>
  ),
  width: 160,
};

const receivedAgingColumn = {
  headerName: 'Received Aging',
  field: 'received_aging',
  isVisible: true,
  sortable: true,
  type: 'numericColumn',
  valueGetter: (params) => {
    const aging = params?.data?.received_aging;
    if (aging === 0 || aging) return Number(aging);
    const receivedAt = params?.data?.received_at;
    if (!receivedAt || !moment(receivedAt).isValid()) return null;
    return moment.utc().startOf('day').diff(moment.utc(receivedAt).startOf('day'), 'days');
  },
  cellRenderer: (params) => {
    const days = params.value;
    if (days === null || days === undefined || Number.isNaN(days)) return 'N/A';
    return <span>{`${days} day${days !== 1 ? 's' : ''}`}</span>;
  },
  width: 120,
};

// Street column
const streetColumn = (incomingVal = null) => ({
  headerName: 'Street',
  field: 'customer_address',
  sortable : true,
  isVisible : true,
  floatingFilterComponentParams: { suppressFilterButton: true },
  valueGetter: (params) => _.get(params, 'data.customer_address.address_line1', '') ,
  cellStyle: {
    textAlign: 'left',
  },
  // width: 140,
});

const pendingOrdersStreetColumn = () => ({
  headerName: I18n.t("general.street"),
  field: 'customer_address',
  sortable: true,
  isVisible: true,
  floatingFilterComponentParams: { suppressFilterButton: true },
  valueGetter: (params) => _.get(params, 'data.customer_address.address_line1', ''),
  cellRenderer: (params) => {
    const addressLine1 = _.get(params, 'data.customer_address.address_line1', '');
    
    return (
      <div style={{ display: "flex" }}>
        <Tooltip
          title={addressLine1}
          placement="topLeft"
          overlayStyle={{ whiteSpace: "pre-wrap" }}
        >
          <div>
            {addressLine1}
          </div>
        </Tooltip>
      </div>
    );
  },
  cellStyle: {
    textAlign: 'left',
  },
  // width: 140,
});


// Address column
const getAddressColumn = (key = null) => {
  const addressColumn =  {
    headerName: 'Address',
    field: 'full_address',
    isVisible: true,
    sortable: true,
    valueGetter: (params) => {
      const sourcePoint = getAddress(params.data, 'pickup');
      const destinationPoint = getAddress(params.data, 'delivery');
      return `${sourcePoint} - ${destinationPoint}`;
    },
    cellRenderer: (params) => {
      const sourcePoint = getAddress(params.data, 'pickup');
      const destinationPoint = getAddress(params.data, 'delivery');
      if (["LH"].includes(params.data.type_of_order)) {
        return `${sourcePoint} -> ${destinationPoint || 'NA'}`;
      } else if (params.data.type_of_order === 'T') {
        // Assuming displayTransferAddress returns a plain text address
        return displayTransferAddress(params.data, key);
      } else {
        return sourcePoint || destinationPoint || 'NA';
      }
    },
    width: 450,
    cellStyle: {
      textTransform: 'uppercase',
    },
  };
  return addressColumn;
};



const getAddressColumnForPreplan = (key = null) => {
  const addressColumn =  {
    headerName: 'Address',
    field: 'full_address',
    isVisible : true,
    valueGetter: (params) => {
      const sourcePoint = getAddressForPreplanCol(params.data, 'pickup');
      const destinationPoint = getAddressForPreplanCol(params.data, 'delivery');
      return `${sourcePoint} - ${destinationPoint}`;
    },
    cellRenderer: (params) => {
      const sourcePoint = getAddressForPreplanCol(params.data, 'pickup');
      const destinationPoint = getAddressForPreplanCol(params.data, 'delivery');
      if (["LH"].includes(params.data.type_of_order)) {
        return (
        <Popover
          content={
            <Row style={{ textAlign: 'center' }}>
              <Col><Tag color="#FF0000">{sourcePoint}</Tag></Col>
              <Col> <Icon type="arrow-down" /></Col>
              <Col><Tag color="#0A7474">{destinationPoint}</Tag></Col>
            </Row>
          }
          title="Address"
        >    <div style={{ display: 'flex' }}>
            <div>{sourcePoint}</div>
            <span>&nbsp;{' -> '}&nbsp;</span>
            <div>{destinationPoint ? destinationPoint : "NA"}</div>
          </div>
        </Popover>
        );
      } else if(params.data.type_of_order === 'T') {
        return displayTransferAddress(params.data,key)
      } else {
        return (
          <div>
            {sourcePoint ? sourcePoint : destinationPoint}
          </div>
        )
      }
    },
  
    sortable : false,
    width: 450,
    cellStyle: {
      textTransform: 'uppercase',
    },
  };
  return addressColumn;
}

const getPickupAddressColumnForPreplan = () => {
  const addressColumn = {
    headerName: 'Pickup Address',
    field: 'pickup_address',
    isVisible: true,
    valueGetter: (params) => getAddressForPreplanCol(params.data, 'pickup', true),
    cellRenderer: (params) =>getAddressForPreplanCol(params.data, 'pickup', true),
    sortable: true,
    width: 350,
    cellStyle: {
      textTransform: 'uppercase'
    }
  }
  return addressColumn;
}

const getDeilveryAddressColumnForPreplan = () => {
  const addressColumn = {
    headerName: 'Delivery Address',
    field: 'delivery_address',
    isVisible: true,
    valueGetter: (params) => getAddressForPreplanCol(params.data, 'delivery', true),
    cellRenderer: (params) => getAddressForPreplanCol(params.data, 'delivery', true),
    sortable: true,
    width: 350,
    cellStyle: {
      textTransform: 'uppercase'
    }
  }
  return addressColumn;
}



// Pickup Address column
const pickupAddressColumn = {
  headerName: 'Pickup Address',
  field: 'PickupAddress', 
  isVisible : true,
  valueGetter: (params) => getAddress(params.data,'pickup'),
  cellRenderer: (params) => getAddress(params.data,'pickup'),
  // cellRenderer: (params) => (getAddress(params.data, 'pickup')),
  sortable: true,
  width: 350, 
  cellStyle: {
    textTransform: 'uppercase',
  },
};

// Delivery Address column
const deliveryAddressColumn = {
  headerName: 'Delivery Address',
  field: 'DeliveryAddress',
  isVisible: true,
  valueGetter: (params) => getAddress(params.data,'delivery'),
  cellRenderer: (params) => (getAddress(params.data, 'delivery')),
  sortable: true,
  width: 350, 
  cellStyle: {
    textTransform: 'uppercase',
  },
};

const estimateBillingColumn = (fn, showRecalculate = true) => {
  return {
    headerName: 'Estimate',
    field: 'estimate',
    isVisible: true,
    valueGetter: ((params) => params?.data?.estimate ? Number(params.data.estimate) : ''),
    cellRenderer: ((params) => {
      return (<EstimateData record={params.data} updateEstimateVal = {fn} showRecalculate={showRecalculate} />);
    }),
  };
};


const getSignedBolColumn = () => {
  return{
    headerName: 'BOL',
    field:"is_pod_signed_bol_exist",
    filter: false,
    isVisible: true,
    valueGetter: ((params) => params.data.is_pod_signed_bol_exist),
    cellRenderer: (params) => {

      const verifyManualBol =  {
        origin: _.get(params,"data.origin.bol_exists",false),
        destination: _.get(params,"data.destination.bol_exists",false)
      };
      const isVerifyManualBolValid = Object.values(verifyManualBol).some(value => !!value)

      // const verifyManualBol = _.get(params, 'data.type_of_order', null) !=="T" ? _.get(params, 'data.bol_picture', null) : {
      //   origin: _.get(params,"data.bol_picture",null),
      //   destination: _.get(params,"data.delivery_bol_picture",null)
      // };
      // const isVerifyManualBolValid = verifyManualBol
      //   ? (typeof verifyManualBol === 'object'
      //     ? Object.values(verifyManualBol).some(value => !!value)
      //     : !_.isEmpty(verifyManualBol))
      //   : false;
      return (<div style={{ color: isVerifyManualBolValid ? 'green' : 'red', textAlign: 'center',overflow: 'hidden', textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',flex: 1}}>
        {isVerifyManualBolValid ? 'Exists' : 'Does Not Exist'}
      </div>)
    },
}};


// Type column
const CustomTypeOrderCellRenderer = (params) => {
  const { data } = params;
  
  return (
    <div className="type-order-cell" style={{ 
      display: 'flex', 
      alignItems: 'center',
      gap: '8px',
      width: '100%'
    }}>
      <div className="type-of-order-tag-container" style={{ 
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: 1
      }}>
        <TypeOfOrder
          order={data}
          orderTypeKey="type_of_order"
          relatedOrderKey="related_order"
          placement="topLeft"
          showBadge={true}
          isInAggrid={true}
          isReenderWithIcon={true}
        />
     </div>
    </div>
  );
};

const cliOrderLabels = {
  RD: 'Delivery Airline',
  OBT: 'P/U',
};

function getTypeFilterText(data = {}, isCLIEnabled = false){
  if (!data) return "";
  const tokens = [];
 const labelKey = data?.extra_code && AppConfig?.typeOfOrderLabels[data?.extra_code] ? data.extra_code : data?.order_label;
  const base = isCLIEnabled ? cliOrderLabels[labelKey] :(AppConfig?.typeOfOrderLabels[labelKey] ?? AppConfig?.typeOfOrderLabels[data?.type_of_order]);
  if (base) tokens.push(base);
  if(['T'].includes(data.type_of_order)){
    tokens.push("pickup");
  }
  return [...new Set(tokens.map(t => String(t).toLowerCase()).filter(Boolean))].join(' '); 
}

export const typeColumn = (isCLIEnabled = false) => ({
  headerName: 'Order Type',
  field: 'type_of_order',
  isVisible: true,
  cellRenderer: CustomTypeOrderCellRenderer,
  valueGetter: (params) => getTypeFilterText(params.data, isCLIEnabled),
  cellStyle: {
    textAlign: 'left',
  },
  width: 80,
});

export const consolidatedTypeColumn = {
  headerName: 'Order Type',
  field: 'order_type',
  isVisible : true,
  cellRenderer: (params) => (
    <div className="type-of-order-tag-container">
      <TypeOfOrder
        order={ params.data }
        orderTypeKey="order_type"
        relatedOrderKey="related_order"
        placement="topLeft"
        showBadge={ true }
        isInAggrid={true}
        isReenderWithIcon={true}
      />
    </div>
  ),
  valueGetter: (params) => AppConfig.orderTypeShortForms[params.data.order_type],
  cellStyle: {
    textAlign: 'left',
  },
  width: 80,
};

// Quantity column
export const quantityColumn = {
  headerName: 'Qty',
  field: 'items_count',
  type: 'numericColumn',
  isVisible : true,
  filter: 'agNumberColumnFilter',
  valueGetter: (params) => params.data.quantity || '',
  width: 100,
};

export const quantitySubordersColumn = {
  headerName: 'Qty',
  field: 'pieces',
  type: 'numericColumn',
  isVisible : true,
  // filter: 'agNumberColumnFilter',
  valueGetter: (params) => params.data.pieces || '',
  width: 100,
};


// Exception column
export const exceptionColumn = {
  headerName: 'Exception Reason',
  field: 'exception_message',
  isVisible : true,
  valueGetter: (params) => _.get(params,'data.exception_message',''),
  cellRenderer:(params) => {
    return (
      <div className="textRed">
        {params.data.exception_message}
      </div>
    )
  },
  width: 160,
};

// On Hold Reason column
const onHoldReasonColumn = {
  headerName: 'On Hold Reason',
  isVisible : true,
  field: 'on_hold_reason',
  valueGetter: (params) => _.get(params,'data.on_hold_reason',''),
  cellRenderer:(params) => {
    return (
      <div className="textRed">
        {params.data.on_hold_reason}
      </div>
    )
  },
  width: 150,
};


// Weight column
export const weightColumn = {
  headerName: 'Weight',
  field: 'weight',
  isVisible : true,
  type: 'numericColumn',
  filter: 'agNumberColumnFilter',
  valueFormatter: params => formatWeight(params.data.weight),
  valueGetter: (params) => params.data.weight || '',
  width:110
};

// Dim Weight column
export const totalDimWeightColumn = {
  headerName: 'Total Dim Weight',
  field: 'total_dim_weight',
  isVisible : true,
  type: 'numericColumn',
  filter: 'agNumberColumnFilter',
  valueFormatter: params => formatWeight(params.data.total_dim_weight),
  valueGetter: (params) => params.data.total_dim_weight || '',
  width:110
};



export const readyForBillingColumn = {
  headerName: 'Ready for Billing',
  field: 'ready_for_billing',
  isVisible : true,
  valueGetter: (params) => params.data.ready_for_billing || '',
  valueGetter: (params) => params.data.ready_for_billing || '',
  width:110
}
export const invoiceColumn = {
  headerName: 'Invoice',
  field: 'invoice',
  isVisible : true,
  valueGetter: (params) => params.data.invoice || '',
  valueGetter: (params) => params.data.invoice || '',
  width:110
}
export const getWeightUnitsColumn = (weightCol, keyName, accountWeightUnits) => {
  if (weightCol) {
    const new_weight_col = {
      ...weightCol,
      width: 130,
      valueFormatter: (params) => {
        const { account_code } = params.data;
        const weight = params.data[ keyName ];

        if (!weight) return '';

        // Get account's preferred unit, default to 'lbs' if not specified
        const preferredUnit = accountWeightUnits?.[ account_code ] || 'lbs';

        // Convert weight based on preferred unit
        if (preferredUnit === 'kgs') {
          const kgs = parseFloat(weight);
          const lbs = convertToPounds(kgs); // Convert kgs to lbs
          // return `${_.round(lbs, 2)} lbs / ${_.round(kgs, 2)} kg`;
          return getFormattedWeight(lbs, kgs);
        } else {
          const lbs = parseFloat(weight);
          const kgs = convertToKilograms(lbs); // Convert lbs to kgs
          return getFormattedWeight(lbs, kgs);
          // return `${_.round(lbs, 2)} lbs / ${_.round(kgs, 2)} kg`;
        }
      },
    };
    return new_weight_col;
  }

  return weightColumn;
}

export const getCombinedWeightunits = (weightCol, roundedDecimals = 2) => {
  if (weightCol) {
    const new_weight_col = {
      ...weightCol,
      width: 130,
      cellRenderer: (params) => {
        return (
          <div className="ellipsis-text">
            {params.data.weight || params.data.weight_in_kgs
              ? `${params.data.weight ? `${params.data.weight.toFixed(roundedDecimals)} lbs` : ""}${params.data.weight && params.data.weight_in_kgs ? " / " : ""}${params.data.weight_in_kgs ? `${params.data.weight_in_kgs.toFixed(roundedDecimals)} kgs` : ""}`
              : "NA"}
          </div>
        )
      },
    };  
    return new_weight_col;
  }

  return weightColumn;
}

// export const getWeightUnitsColumn = (weightCol, keyName, accountWeightUnits) => {
//   if (weightCol) {
//     const new_weight_col = {
//       ...weightCol,
//       valueFormatter: (params) => {
//         const { account_code } = params.data;
//         if (params.data[keyName]) {
//           // return accountWeightUnits[account_code] == "kgs" ? convertToUnitsWithBothLabels(params.data[keyName], "kgs") : params.data[keyName]
//           return convertToUnitsWithBothLabels(params.data[keyName], "kgs") || ''
//         }
//         return ''
//       },
//     }
//     return new_weight_col
//   }

//   return weightColumn;
// }


const vehicleTypeColumn = {
  headerName: 'Vehicle Type',
  field: 'vehicle_type',
  isVisible : true,
  filter: 'agNumberColumnFilter',
  valueGetter: (params) => params.data.vehicle_type || '',
  width:110
};


// lastUpdatedByColumn
const lastUpdatedByColumn = {
  headerName: I18n.t("order.last_updated_by"),
  field: 'created_by',
  isVisible : true,
  valueGetter: (params) => params.data.created_by || '',
  width:110
};


// SkidsPallets column
const skidsPallets = {
  headerName: 'Skids / Pallets',
  field: 'pallets',
  isVisible : true,
  type: 'numericColumn',
  valueGetter: (params) => params.data.pallets || '',
  width:100
};

const age = {
  headerName: 'Age',
  field: 'created_at',
  isVisible : true,
  type: 'numericColumn',
  valueGetter : (params) => moment().diff(moment(params.data.created_at), 'days'),
  cellRenderer: (params) => (
    <div className="paddingRight25">
      <span>{ moment().diff(moment(params.data.created_at), 'days') }</span>
    </div>
  ),
  cellStyle: (params) => ({
    textAlign: 'right',
  }),
}
// const quoteNoColumn = {
//   headerName: I18n.t("general.order_type"),
//   field: 'quote_no',
//   isVisible : true,
//   valueGetter: (params) => params.data.quote_no || '',
//   width: 150
// }

// SC column
const sc = (screen,hideAppointmentdate,organizationSettings ) => ({
  headerName: 'SC',
  field: 'sc',
  filter:false,
  isVisible : true,
  type: 'numericColumn',
  valueGetter: (params) => params.data.order_delivery_time || '',
  width: 100,
  comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
    if (nodeA.data.appointments && nodeA.data.appointments.length > 0 && nodeB.data.appointments && nodeB.data.appointments.length > 0) {
      const dateA = new Date(nodeA.data.appointments[ 0 ].start_datetime);
      const dateB = new Date(nodeB.data.appointments[ 0 ].start_datetime);
      return dateA.getTime() - dateB.getTime();
    }
    return 0;
  },
  cellRenderer: (params) => {
    const data = params.data;
    return (
      <div>
        {data.type_of_order !=="MS" && data.appointments && data.appointments.length > 0 ? (
          <Popover
            size="small"
            content={
              <div className="table-contact-info width500 fontsize12">
                <OrderAppointments
                  appointments={data.appointments || []}
                  timezone={data.tz_short_form}
                  showConfirmedTime={false}
                  locations={data.locations}
                  showPDLabels={["T", "LH"].includes(data.type_of_order) ? true : false}
                  tooltip={false}
                  screen = {screen}
                />
              </div>
            }
            title={I18n.t("appointmentForm.preference_title")}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          >
            <OrderAppointments
              appointments={data.appointments || []}
              timezone={data.tz_short_form}
              showConfirmedTime
              locations={data.locations}
              showPDLabels={["T", "LH"].includes(data.type_of_order) ? true : false}
              tooltip={false}
              screen = {screen}
            />
          </Popover>
        ) : (
          <AppointmentDisplay
          data={data}
          hideAppointmentdate={hideAppointmentdate}
          organizationSettings={organizationSettings}
          showPDLabels={["T", "LH", "MS"].includes(params.data.type_of_order) ? true : false}
          isMultiStop={params.data.type_of_order === "MS"}
        />
        )}
      </div>
    );
  },
  width: 120,
  align: "left",
  sortable: true,
  sortDirections: ["ascend", "descend", "ascend"],
});

// Driver column
const driverColumn = (refreshCallback, columnProps = {}) => ({
  headerName: "Driver",
  field: "driver",
  isVisible: true,
  ...columnProps,
  valueGetter: ({data}) => {
    if (!data) return '';
    
    if (["T", "LH"].includes(data.type_of_order)) {
      const driverValue = formatLocValues("driver_name", data.origin, data.destination);
      return driverValue || '';
    } else {
      if (data?.origin?.driver_name || data?.destination?.driver_name) {
        return formatLocValues("driver_name", data.origin, data.destination) || '';
      }
      return data?.locations?.[0]?.driver_name || '';
    }

  },
  cellRenderer: ({ data }) => {
    if (data?.origin?.driver_name || data?.destination?.driver_name) {
      return <div className="ellipsis-text">
        {formatLocValues("driver_name", data.origin, data.destination)}
      </div>;
    }
    
    const showAssignOrders = ["NEW", "RECEIVED", "VERIFIED"].includes(data?.status);
    const isCDKOrder = data?.order_label === 'CDK' || data?.order_label === 'WO';
    const isCDKDOrder = data?.order_label === 'CDKD' && (data?.origin?.label_code === 'CDK' && data?.origin?.status !== 'COMPLETED'); 
    const isPCDKOrder = data?.order_label === 'PCDK' && (data?.origin?.status === 'COMPLETED' && data?.destination?.label_code === 'CDK');
    const isImportedButNotCleared = data?.is_imported === true || data?.is_imported === "true";
    const selectedWarehouseId = columnProps.warehouseFilter?.getWHDetails?.()?.id || "";
    const hasAssignableLegs = hasQuickDispatchAssignableLegs(
      data,
      columnProps.organizationSettings || {},
      selectedWarehouseId,
    );
    const isAssignDisabled =
      isCDKOrder || isCDKDOrder || isPCDKOrder || isImportedButNotCleared || !hasAssignableLegs;
    const renderAssignOrders = () => (
      <Col align="middle" justify="center"
      style={{
        opacity: isAssignDisabled ? 0.5 : 1,
        pointerEvents: isAssignDisabled ? 'none' : 'auto',
      }}>
        <Row type="flex" align="middle" justify="center">
          <Col style={{ pointerEvents: isAssignDisabled ? 'none' : 'auto' }}>
            <AssignOrders
              isFromColDef
              selectedOrders={[data]}
              isFromBulkContainer={false}
              orderRefreshCall={refreshCallback}
              disabled={isCDKOrder || isImportedButNotCleared || !hasAssignableLegs}
              screenFrom={"orderListRow"}
            />
          </Col>
        </Row>
      </Col>
    );

    if (showAssignOrders) {
      if (isImportedButNotCleared) {
        return (
          <Tooltip title="This is an imported order" placement="top">
            {renderAssignOrders()}
          </Tooltip>
        );
      }
      return renderAssignOrders();
    }
    return null;
  },
});


const preplanstatusColumn = {
  headerName: 'Status',
  field: 'status',
  filter:true,
  isVisible : true,
  width: 130,
};

// Status column
// const statusColumn = {
//   headerName: 'Status',
//   field: 'status',
//   filter:false,
//   isVisible : true,
//   sortable: true,
//   cellRenderer: (params) => (
//     <div>{ retrieveOrderValue(params.data, 'status', true,"beta") }</div>
//   ),
//   valueGetter: (params) => {
//     const record = params.data;
//     if (['T', 'LH'].includes(record.type_of_order)) {
//       return `${record?.origin?.status || ''}${record?.destination?.status || ''}`;
//     } else {
//       return record.status;
//     }
//   },
//   width:250,
// };

const statusColumn = {
  headerName: 'Status',
  field: 'status',
  filter: false,
  isVisible: true,
  sortable: true,
  cellRenderer: (params) => {
    const statusValue = retrieveOrderValue(params.data, 'status', true, "beta");
    return statusValue || '';
  },
  valueGetter: (params) => {
    const record = params.data;
    if (['T', 'LH'].includes(record.type_of_order)) {
      return `${record?.origin?.status || ''}${record?.destination?.status || ''}`;
    } else {
      return record.status;
    }
  },
  width: 250,
};

const ShipperColumn = {
  headerName: "Shipper",
  field: "shipper_name",
  isVisible: true,
  sortable: true,
  width: 150,
  filter: 'agTextColumnFilter',

  valueGetter: (params) => {
    const shipper = params.data?.shipper_name || "NA";
    const company = params.data?.origin?.company_name || "NA";
    return `${shipper} ${company}`;
  },
  getQuickFilterText: (params) => {
    const shipper = params.data?.shipper_name || "NA";
    const company = params.data?.origin?.company_name || "NA";
    return `${shipper} ${company}`;
  },

  cellRenderer: (params) => {
    const shipper = params.data?.shipper_name || "NA";
    const company = params.data?.origin?.company_name || "NA";

    const content = (
      <div>
        <div style={{ fontWeight: 500 }}>{shipper}</div>
        <div style={{ color: "#8c8c8c", fontSize: 12 }}>
          {company}
        </div>
      </div>
    );

    return (
      <Popover content={content} placement="topLeft">
        <div
          style={{
            paddingTop: 8,
            lineHeight: "1.2",
            display: "flex",
            flexDirection: "column",
            cursor: "pointer"
          }}
        >
          <div style={{ fontSize: 13, fontWeight: 500 }}>
            {shipper}
          </div>
          <div style={{ fontSize: 11, color: "#8c8c8c" }}>
            {company}
          </div>
        </div>
      </Popover>
    );
  }
};

  const ConsigneeColumn = {
    headerName: "Consignee",
    field: "consignee_name",
    isVisible: true,
    sortable: true,
    width: 150,
    filter: 'agTextColumnFilter',

    valueGetter: (params) => {
      const consignee = params.data?.consignee_name || "NA";
      const company = params.data?.destination?.company_name || "NA";
      return `${consignee} ${company}`;
    },
    getQuickFilterText: (params) => {
      const consignee = params.data?.consignee_name || "NA";
      const company = params.data?.destination?.company_name || "NA";
      return `${consignee} ${company}`;
    },

    cellRenderer: (params) => {
      const consignee = params.data?.consignee_name || "NA";
      const company = params.data?.destination?.company_name || "NA";

  const content = (
      <div>
        <div style={{ fontWeight: 500 }}>{consignee}</div>
        <div style={{ color: "#8c8c8c", fontSize: 12 }}>
          {company}
        </div>
      </div>
    );

    return (
      <Popover content={content} placement="topLeft">
        <div
          style={{
            paddingTop: 8,
            lineHeight: "1.2",
            display: "flex",
            flexDirection: "column",
            cursor: "pointer"
          }}
        >
          <div style={{ fontSize: 13, fontWeight: 500 }}>
            {consignee}
          </div>
          <div style={{ fontSize: 11, color: "#8c8c8c" }}>
            {company}
          </div>
        </div>
      </Popover>
    );
    }
  };


const quoteStatusCol = {
  headerName: 'Status',
  field: 'status',
  filter: false,
  isVisible: true,
  sortable: true,
  cellRenderer: (params) => {
    const type = ['R', 'TR'].includes(params.data.type_of_order) ? 'P' : ['D', 'TD'].includes(params.data.type_of_order) ? 'D' : 'T';
    const statusValue = renderColumnValue(params.data.status, type, true, null);
    return statusValue || '';
  },
  valueGetter: (params) => {
    const record = params.data;
      return record.status;
  },
  width: 250,
};


// Age column
const ageColumn = {
  headerName: 'Age',
  field: 'created_at',
  type: 'numericColumn',
  isVisible : true,
  filter: 'agNumberColumnFilter',
    // use parseint
  valueGetter : (params) => moment().diff(moment(params.data.created_at), 'days'),  
  cellRenderer: (params) => (
    <div>
      <span>{ moment().diff(moment(params.data.created_at), 'days') }</span>
    </div>
  ),
  cellStyle: (params) => ({
    textAlign: 'right',
  }),
  width: 95,
};

const losColumn = (field = "los", incomingVal = null) => ({
  headerName: I18n.t('general.short_los'),
  field,
  isVisible: true,
  floatingFilterComponentParams: { suppressFilterButton: true },
  valueGetter: (params) => {
    return params.data.level_of_service || params.data.los_name || params.data.levelOfService || "NA"; 
 },
  cellRenderer: (params) =>
    incomingVal === "preplan" ? (
      <div>{params.data.levelOfService || params.data.level_of_service}</div>
    ) : (
      <div>
        {!['T', 'M'].includes(params.data.type_of_order)
          ? (params.data.level_of_service || params.data.levelOfService)
          : `${(params.data?.pickup_location_details?.los_name) || (params?.data?.origin?.level_of_service) } - ${(params?.data?.delivery_location_details?.los_name) || (params?.data?.destination?.level_of_service)}`}
      </div>
    ),
  width: 110,
});

// Zones column
const zonesColumn = {
  headerName: 'Zones',
  field: 'zone_name', 
  floatingFilterComponentParams: { suppressFilterButton: true },
  // filter: 'agTextColumnFilter',
  isVisible : true,
  valueGetter: (params) => {
    const flattenZones = (zones) => {
      return zones?.map((zone) => {
        if (typeof zone === 'object') {
          return flattenZones(Object.values(zone))?.join(', ');
        }
        return zone;
      });
    };

    const allZones = flattenZones(params?.data?.order_zone_name)?.join(', ');
    return allZones;
  },
  cellRenderer: (params) => (
    <ZonesDisplay data={params.data || []} />
  ),
    // width: 152,
};



const getPendingOrderNoColumn = (showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink) => {
  return {
    headerName: I18n.t("order.order_no"),
    field: 'customer_order_number',
    isVisible : true,
    sortable : true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params.data.customer_order_number|| '',
    comparator: (a, b) => {
      const valA = String(a || '');
      const valB = String(b || '');
      return valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' });
    },
    cellRenderer: (params) => {
      const data=params.data;
      const customer_order_number =data.customer_order_number
      const textColor = showTriggerEdit && data.status === "EXCEPTION" ? "textRed" : "";

      return (
        <Row type="flex" align="middle" gutter={4}>
          <Col>
            <TypeOfOrder
              order={data}
              orderTypeKey="type_of_order"
              relatedOrderKey="related_order"
              placement="topLeft"
              showBadge={true}
            />
          </Col>
          <Col style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {checkServiceExistance("COS") ? (
              showTriggerEdit ? (
                <Fragment>
                  <Link className={textColor} onClick={() => handleEditOrder(data.id)}>
                    {data.status === "EXCEPTION" ? (
                      <Popover
                        title="Exception"
                        content={!isEmpty(data.exception_message) ? data.exception_message : "Reason Not Available"}
                        overlayClassName="popoverWidth"
                      >
                        {data}
                      </Popover>
                    ) : (
                      data
                    )}
                  </Link>
                  {data?.is_rebill_order === "true" && (
                    <Tooltip title="Rebilled Order" placement="top">
                      <RebillIcon />
                    </Tooltip>
                  )}
                  <Copyable text={customer_order_number} />
                </Fragment>
              ) : showDetailsLink !== false ? (
                <Fragment>
                <CustomerOrderDetails
                  order_no={customer_order_number}
                  order={{
                    id: data.id,
                    customer_order_number: customer_order_number,
                  }}
                  showEdit={!["REJECTED"].includes(data.status)}
                  editClick={() => handleEditOrder(data.id)}
                  refreshCallback={refreshCallback}
                />
                {data?.is_rebill_order === "true" && (
                  <Tooltip title="Rebilled Order" placement="top">
                    <RebillIcon />
                  </Tooltip>
                )}
                </Fragment>
              ) : (
                <Fragment>
                  <span className={textColor}>{customer_order_number}</span>
                  {data?.is_rebill_order === "true" && (
                    <Tooltip title="Rebilled Order" placement="top">
                      <RebillIcon />
                    </Tooltip>
                  )}
                </Fragment>
              )
            ) : (
              <Fragment>
                <span className={textColor}>{customer_order_number}</span>
                {data?.is_rebill_order === "true" && (
                  <Tooltip title="Rebilled Order" placement="top">
                    <RebillIcon />
                  </Tooltip>
                )}
              </Fragment>
            )}
          </Col>
        </Row>
      );
    },
  };
};

const getSubOrdersOrderNoColumn = () => {
  return {
    headerName: I18n.t("order.order_no"),
    field: 'customer_order_number',
    isVisible : true,
    sortable : true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params.data.customer_order_number|| '',
    comparator: (a, b) => {
      const valA = String(a || '');
      const valB = String(b || '');
      return valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' });
    },
    cellRenderer: (params) => {
      const data=params.data;
      return (
        <Row type="flex" align="middle" gutter={4}>
          <Col>
            <TypeOfOrder
              order={data}
              orderTypeKey="type_of_order"
              relatedOrderKey="related_order"
              placement="topLeft"
              showBadge={true}
            />
          </Col>
          <Col style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span>{data.customer_order_number}</span>
            {data?.is_rebill_order === "true" && (
              <Tooltip title="Rebilled Order" placement="top">
                <RebillIcon />
              </Tooltip>
            )}
          </Col>
        </Row>
      )
    }
}
}

// export const getOrderNoColumn = (showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink,gotoOrderDetails, incomingVal = null , showEditIcon = true) => {
export const getOrderNoColumn = (showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink, gotoOrderDetails, showStatusColor = true,statusColorContext, incomingVal = null, showEditIcon = true) => {
  const orderNoColumn = {
    headerName: 'Order No',
    field: 'customer_order_number',
    isVisible : true,
    cellRenderer: (params) => renderOrderNumType(params.data.customer_order_number, params.data, showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink, true, gotoOrderDetails, showEditIcon, showStatusColor,statusColorContext),
    width: 170,
    rowDragText: (params) => setDragMetaAndGetText(params, "ORDER"),
    comparator: (a, b) => {
      const valA = String(a || '');
      const valB = String(b || '');
      return valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' });
    },
  };
  if(incomingVal && (incomingVal === "preplan")){
    orderNoColumn.rowDrag = (params) => {
      return !params.data.account_limit_exceeded;
    }
  }
  return orderNoColumn;
};

export const getRequiredPlacardColumn = (params) => {
  return {
    headerName: 'Required Placard',
    field: 'required_placard',
    isVisible : true,
    cellRenderer: (params) => {
      const data = params.data;
    return (
      <div>
            {data?.is_placard_required ? "YES": "NO"|| "NA"}
      </div>
    );
  }
}
}


export const getOrderNoPreplanColumn = (showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink, gotoOrderDetails, showStatusColor = true, statusColorContext, incomingVal = null, showEditIcon = true) => {
  const CustomOrderCellRenderer = (params) => {
    const data = params.data;
    // Find color object for status if enabled
      let foundObj = null;
    if (showStatusColor && statusColorContext) {
      foundObj = getDispatchColorObject(data);
    }

    // Style for colored status background
    const colorStyle = foundObj ? {
      backgroundColor: foundObj.color,
      color: getContrastColor(foundObj.color),
      padding: '2px 8px',
      borderRadius: '4px'
    } : {};

    return (
      <div className="order-cell-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
      onMouseDown={() => applyRowDragMetaToLiveRow(params, "ORDER")}
      >
        {/* Order Type Icon */}
        <div className="order-type-icon">
          <TypeOfOrder
            order={data}
            orderTypeKey="type_of_order"
            relatedOrderKey="related_order"
            placement="topLeft"
            showBadge={true}
          />
        </div>

        {/* Order Number with Overflow Handling */}
        <div style={{ 
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1
        }}>
          {showTriggerEdit ? (
            <Link
              onClick={() => handleEditOrder(data.id)}
              style={{ textDecorationColor: foundObj ? getContrastColor(foundObj?.color) : 'black' }}
            >
              {colorTagToolTip(foundObj, data.customer_order_number)}
            </Link>
          ) : showDetailsLink !== false ? (
            <Link 
              onClick={() => gotoOrderDetails(data.id)}
              style={{ textDecorationColor: foundObj ? getContrastColor(foundObj?.color) : 'inherit' }}
            >
                {colorTagToolTip(foundObj, data.customer_order_number)}
            </Link>
          ) : (
            <span style={colorStyle}>{data.customer_order_number}</span>
          )}
        </div>
        {data.is_osd &&
        <Tooltip title={"OSD"} placement="top">
          <OsdIcon width={16} height={16}/>
        </Tooltip>
         }


        {/* Customs Hold Icon — shown when imported but not yet cleared */}
        {(data.is_imported === true || data.is_imported === "true") &&
         !(data.is_customs_cleared === true || data.is_customs_cleared === "true") && (
          <Tooltip title="Customs Clearance Pending" placement="top">
            <Icon type="alert" style={{ fontSize: '15px', color: '#f94016ff' }} />
          </Tooltip>
        )}

        {/* Crown Icon — shown when imported AND customs cleared (special order) */}
        {(data.is_imported === true || data.is_imported === "true") &&
         (data.is_customs_cleared === true || data.is_customs_cleared === "true") && (
          <Tooltip title="Imported & Customs Cleared" placement="top">
            <Icon type="crown" style={{ fontSize: '15px', color: '#55B80F' }} theme="filled" />
          </Tooltip>
        )}

        {/* Bonded Order Icon */}
        {(data.is_inbound === true || data.is_inbound === "true") && (
          <Tooltip title="Bonded Order" placement="top">
            {/* <Icon type="api" theme="filled" style={{ fontSize: '15px', color: '#576ec1' }} /> */}
            <CustomsOfficerIcon width={24} height={24} color="#D97706" />
          </Tooltip>
        )}

        {data.is_split_order && (
          <Tooltip title="Split Order" placement="top">
            <Icon type="apartment" style={{ fontSize: 14, color: "#534AB7" }} />
          </Tooltip>
        )}
        {(data?.is_hazardous) && (
          <Tooltip title="Hazmat" placement="top">
            {HazmatIndicationImg()}
          </Tooltip>
        )}
        {(data.is_rebill_order === "true" || data.is_rebill_completed === "true") && (
          <Tooltip title="Rebilled Order" placement="top">
            <RebillIcon />
          </Tooltip>
        )}

        {/* Agent Tendered/Drafted Icon — popover mounts lazily on first hover.
            TENDERED = purple, SAVED (draft) = amber: drafts hide the order from
            preplan/dispatch, so the listing must show why it disappeared. */}
        {(data.agent_tender_state || data.is_agent_tendered === true || data.is_agent_tendered === "true") && (
          <AgentTenderIndicator key={`tender-${data.id}`} order={data} />
        )}

        {/* Copy Button */}
        {data.customer_order_number && (
          <div style={{ flexShrink: 0 }}>
            <Copyable text={data.customer_order_number} />
          </div>
        )}
      </div>
    );
  };

  return {
    headerName: 'Order No',
    field: 'customer_order_number',
    isVisible: true,
    cellRenderer: CustomOrderCellRenderer,
    width: 200,
    rowDragText: (params) => setDragMetaAndGetText(params, "ORDER"),
    rowDrag: incomingVal === "preplan" ? 
      (params) => !params.data.account_limit_exceeded : 
      undefined,
    comparator: (a, b, nodeA, nodeB) => {
    const getHexColor = (node) => node?.data?.color_tags?.[0]?.code?.toLowerCase() || '';

    const colorA = getHexColor(nodeA);
    const colorB = getHexColor(nodeB);

    const hasColorA = !!colorA;
    const hasColorB = !!colorB;

    // Orders with color go to the top
    if (hasColorA && !hasColorB) return -1;
    if (!hasColorA && hasColorB) return 1;

      // Both have color but different colors, sort by hex value (alphabetical)
      if (hasColorA && hasColorB && colorA !== colorB) {
        return colorA.localeCompare(colorB);
      }

      // If both have no color or the same color, sort by order number (natural sort)
      const orderA = String(a || '');
      const orderB = String(b || '');
      return orderA.localeCompare(orderB, undefined, { numeric: true, sensitivity: 'base' });
    }  
  };
};

export const getLinehaulOrderNumber = (gotoOrderDetails, incomingVal = null) => {
  const linehaulOrderNo = {
    headerName: 'Linehaul No',
    field: 'linehaul_order_number',
    isVisible : true,
    cellRenderer: (params) => {
      return (
        <Link onClick={() => gotoOrderDetails(params.data.linehaul_order_id)}>
          {params.data.linehaul_order_number}
        </Link>
      )

    },
    width: 170,
  };
  if(incomingVal && (incomingVal === "preplan")){
    linehaulOrderNo.rowDrag = (params) => {
      return !params.data.account_limit_exceeded;
    }
  }
  return linehaulOrderNo;
};

export const getHawbColumn = (showTriggerEdit, handleEditOrder, refreshCallback, incomingVal = null, showEditIcon = true) => {
  const mawbColumn = {
    headerName: 'HAWB',
    field: 'hawb',
    isVisible : true,
    cellRenderer: (params) => 
      <div style={{ paddingLeft: 7 }} onMouseDown={() => applyRowDragMetaToLiveRow(params, "ORDER")}>
        <OrderFieldDisplay data={params.data} showEditIcon={showEditIcon} toDisplay="hawb" showTriggerEdit={showTriggerEdit} editClick={() => handleEditOrder(params.data.id)} refreshCallback={refreshCallback} charsToLimit={null} />
      </div>,
    width: 140,
    rowDragText: (params) => setDragMetaAndGetText(params, "ORDER"),
  };
  if(incomingVal && (incomingVal === "preplan")){
    mawbColumn.rowDrag = (params) => {
      return !params.data.account_limit_exceeded && params.data.hawb && params.data.hawb.length;
    }
  }
  return mawbColumn;
};

/*const getHawbNoColumn = (showTriggerEdit, showDetailsLink, handleEditOrder, gotoOrderDetails, statusColorContext, showStatusColor = false,) => {
  const hawbColumn = {
    headerName: 'HAWB',
    field: 'hawb',
    isVisible : true,
    cellRenderer: (params) => {
      let foundObj = _.get(params.data, 'color_tags[0]', null);
      const dataToDisplay = params.data.hawb;
      return (
        <div style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1
        }}>
                {showTriggerEdit ? (
                  <Row type="flex" gutter={8}>
                  <Col>
                  <Link onClick={() => handleEditOrder(params.data.id)}>
                  {dataToDisplay}
                  </Link>
                  </Col>
                  <div className="ellipsis-text">
                  <Col>
                  {params.data.hawb && (
                    <Copyable text={params.data.hawb}/>
                  )}
                  </Col>
                  </div>
                  </Row>
                ) : showDetailsLink !== false ? (
               <Row type="flex" gutter={8} style={{ flexFlow: "nowrap" }}>
                  <Col style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                  {params.data.hawb && <Link onClick={() => gotoOrderDetails(params.data.id)} style={{ textDecorationColor: foundObj ? getContrastColor(foundObj?.color) : 'black' }}>
                    <span
                      className={showStatusColor ? "statusColored" : null}
                      style={foundObj ? colorStatusStyle(foundObj) : null}
                    >
                      {foundObj ? colorTagToolTip(foundObj, dataToDisplay) : dataToDisplay}
                    </span>
                  </Link>
                  }
                  </Col>
                  <div className="ellipsis-text">
                  <Col>
                  {params.data.hawb && (
                    <Copyable text={params.data.hawb}/>
                  )}
                  </Col>
                  </div>
                  </Row>
                ) : (
                  <></>
                )}
        </div>
      )
    },
    width: 140,
  };
  return hawbColumn;
}; */
const CustomHawbCellRenderer = (params) => {
  const { data, showStatusColor, statusColorContext, showTriggerEdit, showDetailsLink, handleEditOrder, gotoOrderDetails } = params;

  // Find color object for status if enabled
  let foundObj = null;
  if (showStatusColor && statusColorContext) {
    const colorArr = statusColorContext || [];
    foundObj = colorArr.find((e) => e.code === data?.color_tags?.[0]?.code);
  }

  // Style for colored status background
  const colorStyle = foundObj ? {
    backgroundColor: foundObj.color,
    color: getContrastColor(foundObj.color),
    padding: '2px 8px',
    borderRadius: '4px'
  } : {};

  return (
    <div className="hawb-cell-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {/* HAWB Number with Overflow Handling */}
      <div className="ellipsis-text">
        {showTriggerEdit ? (
          <Link onClick={() => handleEditOrder(data.id)}>
            {ellipseText(data.hawb, null, true, null, false)}
          </Link>
        ) : showDetailsLink !== false ? (
          <Link 
            onClick={() => gotoOrderDetails(data.id)}
            style={{ textDecorationColor: foundObj ? getContrastColor(foundObj?.color) : 'inherit' }}
          >
            <span
              className={showStatusColor ? "statusColored" : null}
              // style={colorStyle}
            >
              {colorTagToolTip(foundObj, ellipseText(data.hawb, null, false, null, false))}
            </span>
          </Link>
        ) : null}
      </div>

      {/* Copy Button */}
      {data.hawb && (
        <div style={{ flexShrink: 0 }}>
          <Copyable text={data.hawb} />
        </div>
      )}
    </div>
  );
};

const getHawbNoColumn = (showTriggerEdit, showDetailsLink, handleEditOrder, gotoOrderDetails, statusColorContext, showStatusColor = false) => {
  return {
    headerName: 'HAWB',
    field: 'hawb',
    isVisible: true,
    cellRenderer: (params) => CustomHawbCellRenderer({ 
      ...params, 
      showStatusColor, 
      statusColorContext, 
      showTriggerEdit, 
      showDetailsLink, 
      handleEditOrder, 
      gotoOrderDetails 
    }),
    width: 140,
  };
};


/*export const getMawbNoColumn = (showTriggerEdit, showDetailsLink, handleEditOrder, gotoOrderDetails, statusColorContext, showStatusColor = false,) => {
  const mawbColumn = {
    headerName: 'MAWB',
    field: 'mawb',
    isVisible : true,
    cellRenderer: (params) => {
      let foundObj = _.get(params.data, 'color_tags[0]', null)
      const dataToDisplay = params.data.mawb;
      return (
        <Col>
                {showTriggerEdit ? (
                  <Row type="flex" gutter={8}>
                  <Col>
                  <Link onClick={() => handleEditOrder(params.data.id)}>
                  {dataToDisplay}
                  </Link>
                  </Col>
                  <Col>
                  {params.data.mawb && (
                    <Copyable text={params.data.mawb}/>
                  )}
                  </Col>
                  </Row>
                ) : showDetailsLink !== false ? (
               <Row type="flex" gutter={8} style={{ flexFlow: "nowrap" }}>
                <Col className="contrastColorAnchor" style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>

                  {params.data.mawb && <Link onClick={() => gotoOrderDetails(params.data.id)} style={{ textDecorationColor: foundObj ? getContrastColor(foundObj?.color) : 'black' }}>
                    <span
                      className={showStatusColor ? "statusColored" : null}
                      style={colorStatusStyle(foundObj)}
                    >
                      {foundObj ? colorTagToolTip(foundObj, dataToDisplay) : dataToDisplay}
                    </span>
                  </Link>
                  }
                  </Col>
                  <Col>
                  {params.data.mawb && (
                    <Copyable text={params.data.mawb}/>
                  )}
                  </Col>
                  </Row>
                ) : (
                  <></>
                )}
              </Col>
      )
    },
    width: 140,
  };
  return mawbColumn;
}; */

const CustomMawbCellRenderer = (params) => {
  const { data, showStatusColor, statusColorContext, showTriggerEdit, showDetailsLink, handleEditOrder, gotoOrderDetails } = params;

  // Find color object for status if enabled
  let foundObj = null;
  if (showStatusColor && statusColorContext) {
    const colorArr = statusColorContext || [];
    foundObj = colorArr.find((e) => e.code === data?.color_tags?.[0]?.code);
  }

  // Style for colored status background
  const colorStyle = foundObj ? {
    backgroundColor: foundObj.color,
    color: getContrastColor(foundObj.color),
    padding: '2px 8px',
    borderRadius: '4px'
  } : {};

  return (
    <div className="mawb-cell-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {/* MAWB Number with Overflow Handling */}
      <div className="ellipsis-text">
        {showTriggerEdit ? (
          <Link onClick={() => handleEditOrder(data.id)}>
            {ellipseText(data.mawb, null, true, null, false)}
          </Link>
        ) : showDetailsLink !== false ? (
          <Link 
            onClick={() => gotoOrderDetails(data.id)}
            style={{ textDecorationColor: foundObj ? getContrastColor(foundObj?.color) : 'inherit' }}
          >
            <span
              className={showStatusColor ? "statusColored" : null}
              // style={colorStyle}
            >
              {colorTagToolTip(foundObj, ellipseText(data.mawb, null, false, null, false))}
            </span>
          </Link>
        ) : null}
      </div>

      {/* Copy Button */}
      {data.mawb && (
        <div style={{ flexShrink: 0 }}>
          <Copyable text={data.mawb} />
        </div>
      )}
    </div>
  );
};

export const getMawbNoColumn = (showTriggerEdit, showDetailsLink, handleEditOrder, gotoOrderDetails, statusColorContext, showStatusColor = false) => {
  return {
    headerName: 'MAWB',
    field: 'mawb',
    isVisible: true,
    cellRenderer: (params) => CustomMawbCellRenderer({ 
      ...params, 
      showStatusColor, 
      statusColorContext, 
      showTriggerEdit, 
      showDetailsLink, 
      handleEditOrder, 
      gotoOrderDetails 
    }),
    width: 140,
  };
};

export const getMawbColumn = (showTriggerEdit, handleEditOrder, refreshCallback, incomingVal = null, showEditIcon = true) => {
  const mawbColumn = {
    headerName: 'MAWB',
    field: 'mawb',
    isVisible : true,
    cellRenderer: (params) => 
      <div style={{ paddingLeft: 7 }} onMouseDown={() => applyRowDragMetaToLiveRow(params, "ORDER")}>
        <OrderFieldDisplay data={params.data} toDisplay="mawb" showTriggerEdit={showTriggerEdit} showEditIcon={showEditIcon} editClick={() => handleEditOrder(params.data.id)} refreshCallback={refreshCallback} charsToLimit={null} />
      </div>,
    width: 140,
    rowDragText: (params) => setDragMetaAndGetText(params, "ORDER"),
  };
  if(incomingVal && (incomingVal === "preplan")){
    mawbColumn.rowDrag = (params) => {
      return !params.data.account_limit_exceeded && params.data.mawb && params.data.mawb.length;
    }
  }
  return mawbColumn;
};

const getAppointmentsColumn = (hideAppointmentdate, organizationSettings, warehouseFilter = {}, refreshCallback = () => { }, isShipper = false) => {
  const appointmentsColumn = {
    headerName: I18n.t("general.appointments"),
    field: 'appointment',
    filter: false,
    isVisible: true,
    sortable: true,
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const dateA = nodeA.data.appointments[ 0 ]?.start_datetime;
      const dateB = nodeB.data.appointments[ 0 ]?.start_datetime;
      if (!dateA) return 1;
      if (!dateB) return -1;
      return new Date(dateA) - new Date(dateB);
    },
    valueGetter: (params) => {
      return params.data.appointments[ 0 ]?.start_datetime;
    },
    cellRenderer: (params) => (
      <AppointmentDisplay
        data={params.data}
        hideAppointmentdate={hideAppointmentdate}
        organizationSettings={organizationSettings}
        showPDLabels={["T", "LH", "MS"].includes(params.data.type_of_order) ? true : false}
        isMultiStop={params.data.type_of_order === "MS"}
        warehouseFilter={warehouseFilter}
        refreshCallback={refreshCallback}
        isShipper={isShipper}

      />
    ),
    width: 190,
  };

  return appointmentsColumn;
};

const getWindowTimeColumn = (hideAppointmentdate, organizationSettings) => {
  const windowTimeColumn = {
    headerName: 'Window Time',
    field: 'window_time',
    filter: false,
    isVisible: true,
    sortable: true,
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const dateA = nodeA.data.appointments[ 0 ]?.start_window_time;
      const dateB = nodeB.data.appointments[ 0 ]?.start_window_time;
      if (!dateA) return 1;
      if (!dateB) return -1;
      return new Date(dateA) - new Date(dateB);
    },
    valueGetter: (params) => {
      return params.data.appointments[0]?.start_window_time;
    },
    cellRenderer: (params) => (
      <WindowTimeDisplay
        data={params.data}
        hideAppointmentdate={hideAppointmentdate}
        organizationSettings={organizationSettings}
        showPDLabels={["T", "LH", "MS"].includes(params.data.type_of_order) ? true : false}
        isMultiStop={params.data.type_of_order === "MS"}
      />
    ),
    width: 190,
  }

  return windowTimeColumn;
}

const getVehicleTypeColumn = (vhTypes) => {
  const vehicleTypeColumn = {
    headerName: 'Vehicle Type',
    field: 'vehicle_type',
    filter: true,
    isVisible : true,
    sortable : true,
    cellRenderer: (params) => <VehicleImageData record={ params.data.vehicle_type } vhType={ vhTypes } showVehicleTitle />,
    width: 100, 
    // valueGetter: (params) => {
    //   return vhTypes[params.data.vehicle_type] || 'Unknown'; 
    // },
    
  };
  return vehicleTypeColumn;
};

const getHazmatClassColumn = () => {
  const hazmatColumn = {
    headerName: 'Hazmat Class',
    field: 'hazmat_class',
    filter: true,
    isVisible : true,
    sortable : false,
    width: 100,
    cellRenderer: (params) => {
      if (!params.data.hazmat_class) {
        return null;
      }

      return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }} >
        <HazmatImg hazmatClass={params.data.hazmat_class} />
        <span className="ellipsis-text">{params.data.hazmat_class}</span>
      </div>
    )
  }
  };
  return hazmatColumn;
}

const getHazmatDivisionColumn = () => {
  const hazmatDivisionColumn = {
    headerName: 'Hazmat Division',
    field: 'hazmat_division',
    filter: true,
    isVisible : true,
    sortable : false,
    width: 130,
    cellRenderer: (params) => {

      if (!params.data.hazmat_division) {
        return null;
      }

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <HazmatImg hazmatClass={params.data.hazmat_division} />
          <span className="ellipsis-text">{params.data.hazmat_division}</span>
        </div>
    )}
  };
  return hazmatDivisionColumn;
}

const getTagsColumn = () => {
  const tagsColumn = {
    headerName: 'Tags',
    field: 'tags',
    filter: true,
    isVisible: true,
    sortable: true,
    cellRenderer: (params) => {
      const tags = Array.isArray(params.data.tags) ? params.data.tags : [];
      if (tags.length === 0) {
        return <span>Not Added</span>; 
      }
      return (
        <div className="tagContainer" title={tags.join(', ')}>
          {tags.filter((tag) => tag !== "special").map((tag, index) => (
          <span
            key={index}
            className="tagOrderView"
          >
            <div className="ellipsis-text"> 
              {_.startCase(tag)}
              {index < tags.length - 1 && ","}
            </div>
          </span>
        ))}
      </div>
      );
    },
    width: 200,
  };
  return tagsColumn;
};




const getVehicleImageColumn = (vhTypes) => {
  const vehicleImageColumn = {
    headerName: 'Vehicle Image',
    field: 'vehicle_image',
    sortable : false,
    filter: false,
    isVisible : true,
    cellRenderer: (params) => <VehicleImageData record={ params.data.vehicle_type } vhType={ vhTypes } width={ '30' } borderRadius={ '5' } align={ 'center' } showImage />,
  };
  return vehicleImageColumn;
};

export const getZipcodeColumn = (resolvedAddressCallback, incomingVal = null, setOrderInfo, orderInfo) => {
  const renderValidateLocationErr = (record, zipcode, locationId, lAddress, locationPartialMatch) => (
    <ValidateLocationErr
      record={ {
        ...record,
        zipcode,
        location_id: locationId,
        l_address: lAddress,
        location_partial_match: locationPartialMatch
      } }
      displayKey="zipcode"
      errorKey="location_partial_match"
      errorValue={ true }
      refreshCallback={ resolvedAddressCallback }
      loadMaps={ false }
      setOrderInfo={ setOrderInfo }
      orderInfo={ orderInfo }
    />
  );

  const renderZipcodePair = (prefix, zipcode, record, locationId, lAddress, locationPartialMatch) => (
    <>
      { prefix }: { renderValidateLocationErr(record, zipcode, locationId, lAddress, locationPartialMatch) }
    </>
  );

  const getZipcodes = (params) => {
    const data = params.data;
    let zipcodes = [];
  
    if (incomingVal === "preplan" && [ "T", "LH" ].includes(data.type_of_order)) {
      const locations = data.locations;
      if (locations.length === 1) {
        zipcodes.push(_.get(locations[0], 'l_address.zipcode', null));
      } else {
        const pickup = locations.find(location => location.type_of_loc === "PICKUP");
        const delivery = locations.find(location => location.type_of_loc === "DELIVERY");
        zipcodes.push(
          _.get(pickup, 'l_address.zipcode', null),
          _.get(delivery, 'l_address.zipcode', null)
        );
      }
    } else if ([ "T", "LH" ].includes(data.type_of_order)) {
      zipcodes.push(
        _.get(data, 'origin.zipcode', null),
        _.get(data, 'destination.zipcode', null)
      );
    } else {
      zipcodes.push(_.get(data, 'customer_zipcode', null));
    }
  
    // Filter out falsy values
    return zipcodes.filter(Boolean);
  };

  return {
    headerName: "Zipcode",
    field: "zipcode",
    isVisible: true,
    filter: true,
    sortable: true,
    valueGetter: (params) => getZipcodes(params).join('-'),
    cellRenderer: (params) => {
      const data = params.data;
      const zipcodes = getZipcodes(params);

      if (zipcodes.length === 1) {
        return renderValidateLocationErr(
          incomingVal === "preplan" ? data : (_.get(data, "origin", "destination")),
          zipcodes[ 0 ],
         ( _.get(data, 'cs_location_id') || _.get(data, 'locations[0].id')),
         incomingVal === "preplan" ?  ( _.get(data, 'customer_address') || _.get(data, 'locations[0].l_address')) : (_.get(data, "origin","destination")),
         incomingVal === "preplan" ?  (_.get(data, 'location_partial_match') || _.get(data, 'locations[0].location_partial_match')) : (_.get(data,"origin.location_partial_match", "destination.location_partial_match"))
        );
      } else {
        const [ pickupZipcode, dropZipcode ] = zipcodes;
        return (
          <>
            { !_.isEmpty(pickupZipcode) && renderZipcodePair(
              "P",
              pickupZipcode,
              incomingVal === "preplan" ? data : (_.get(data, "origin")),
               incomingVal === "preplan" ? ( _.get(data, 'pickup_location_id') || _.get(data, 'locations', []).find(l => l.type_of_loc === 'PICKUP')?.id) : (_.get(data,"origin.id")),
               incomingVal === "preplan" ? (_.get(data, 'origin') || _.get(data, 'locations', []).find(l => l.type_of_loc === 'PICKUP')?.l_address) : (_.get(data, "origin")),
               incomingVal === "preplan" ? (_.get(data, 'origin.location_partial_match') || _.get(data, 'locations', []).find(l => l.type_of_loc === 'PICKUP')?.location_partial_match) : (_.get(data,"origin.location_partial_match"))
            ) }
            { !_.isEmpty(pickupZipcode) && !_.isEmpty(dropZipcode) && <>&nbsp;{ " - " }&nbsp;</> }
            { !_.isEmpty(dropZipcode) && renderZipcodePair(
              "D",
              dropZipcode,
              incomingVal === "preplan" ? data : (_.get(data, "destination")),
              incomingVal === "preplan" ? (_.get(data, 'delivery_location_id') || _.get(data, 'locations', []).find(l => l.type_of_loc === 'DELIVERY')?.id) : (_.get(data,"destination.id")),
              incomingVal === "preplan" ? (_.get(data, 'destination') || _.get(data, 'locations', []).find(l => l.type_of_loc === 'DELIVERY')?.l_address) : (_.get(data, "destination")),
              incomingVal === "preplan" ? ( _.get(data, 'destination.location_partial_match') || _.get(data, 'locations', []).find(l => l.type_of_loc === 'DELIVERY')?.location_partial_match) : (_.get(data,"destination.location_partial_match"))
            ) }
          </>
        );
      }
    },
    cellStyle: {
      textAlign: "right",
    },
    width: 110,
  };
};

const setZipcodeColumn = (refreshCallback) => {
  const zipcodeColumn = {
    headerName: "Zipcode",
    field: "zipcode",
    isVisible: true,
    filter: true,
    sortable: true,
    width: 120,
    valueGetter: (params) => {
      const data = params.data;
      if (["T", "LH"].includes(data.type_of_order)) {
        const originZipcode = _.get(data.origin, 'zipcode', '') || '';
        const destinationZipcode = _.get(data.destination, 'zipcode', '') || '';
        return `P: ${originZipcode || 'NA'} - D: ${destinationZipcode || 'NA'}`;
      } else {
        return data.customer_zipcode || 'NA';
      }
    },
    cellRenderer: (params) => {
      const data = params.data;
      if (["T", "LH"].includes(data.type_of_order)) {
        const originZipcode = _.get(data.origin, 'zipcode', '') || '';
        const destinationZipcode = _.get(data.destination, 'zipcode', '') || '';
        return (
          <>
            P:{" "}
            {originZipcode ? (
              <ValidateLocationErr
                record={{
                  ...data,
                  zipcode: originZipcode,
                  location_id: data.origin.location_id,
                  l_address: data.origin,
                  location_partial_match: data.origin.location_partial_match
                }}
                displayKey={"zipcode"}
                errorKey={"location_partial_match"}
                errorValue={true}
                refreshCallback={refreshCallback}
                loadMaps={true}
              />
            ) : "NA"}
            &nbsp;{" - "}&nbsp;
            D:{" "}
            {destinationZipcode ? (
              <ValidateLocationErr
                record={{
                  ...data,
                  zipcode: destinationZipcode,
                  location_id: data.destination.location_id,
                  l_address: data.destination,
                  location_partial_match: data.destination.location_partial_match
                }}
                displayKey={"zipcode"}
                errorKey={"location_partial_match"}
                errorValue={true}
                refreshCallback={refreshCallback}
                loadMaps={true}
              />
            ) : "NA"}
          </>
        );
      } else {
        return (
          <div>
            <ValidateLocationErr
              record={{
                ...data,
                zipcode: data.customer_zipcode,
                location_id: data.cs_location_id,
                l_address: data.customer_address,
                location_partial_match: data.location_partial_match
              }}
              data={data}
              displayKey={"zipcode"}
              errorKey={"location_partial_match"}
              errorValue={true}
              refreshCallback={refreshCallback}
              loadMaps={true}
            />
          </div>
        );
      }
    }
  };
  return zipcodeColumn;
};

const getOrdersLosColumn = () => {
  const losColumn = {
    headerName: I18n.t('general.short_los'),
    field: "los",
    isVisible: true,
    filter: true,
    sortable: true,
    width: 120,
    valueGetter: (params) => {
      const record = params.data;
      if (["T", "LH"].includes(record.type_of_order)) {
        const originLos = record?.origin?.level_of_service;
        const destinationLos = record?.destination?.level_of_service;
        return `P: ${originLos || 'None'} - D: ${destinationLos || 'None'}`;
      } else {
        return record.levelOfService || 'None';
      }
    },
    cellRenderer: (params) => {
      const record = params.data;
      if (["T", "LH"].includes(record.type_of_order)) {
        const originLos = record?.origin?.level_of_service;
        const destinationLos = record?.destination?.level_of_service;
        return (
          <>
            P: {originLos || 'None'}
            &nbsp;-&nbsp;
            D: {destinationLos || 'None'}
          </>
        );
      } else {
        return record.levelOfService || 'None';
      }
    }
  };
  return losColumn;
};

// "Service Level" column (Mode A): backend resolves service_level_id -> name
// per row (service_level_name). Only rendered when the org has
// service_level_flow_enabled — see the gates in the per-screen col builders.
// sortable: false — the name is attached after backend sort/pagination.
const getServiceLevelColumn = () => ({
  headerName: I18n.t('order.service_level'),
  field: "service_level_name",
  isVisible: true,
  filter: true,
  sortable: false,
  width: 140,
  valueGetter: (params) => params.data?.service_level_name || "",
  cellRenderer: (params) => params.data?.service_level_name || "",
});

const getCompanyNameColumn = (navigateToAccount) => {
  const companyNameColumn = {
    headerName: 'Company Name',
    field: 'company_name',
    isVisible : true,
    sortable : true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => {
      let content;
      if (params.data.type_of_order === "T") {
        const pickupLocation = params.data?.origin;
        const deliveryLocation = params.data?.destination;
        content = formatPickupDeliveryCompanyNames(pickupLocation, deliveryLocation);
      } else {
        content = params.data.company_name;
      }
      return content;
    },
    cellRenderer: (params) => {
      const hasAccess = checkServiceExistance(['OPSAS', 'ACNF'], 'ALL');
      let content;

      if (params.data.type_of_order === "T") {
        content = formatPickupDeliveryCompanyNames(
          params.data?.origin,
          params.data?.destination
        );
      } else {
        content = params.data.company_name;
      }

      return content;
    },
  };
  return companyNameColumn;
};

const getPickupColumnForPreplans = (navigateToAccount) => {
  const companyNameColumn = {
    headerName: "Company Name (P)",
    field: "company_name_pickup",
    isVisible: true,
    sortable: true,
    floatingFilterComponentParams: { suppressFilterButton: true },

    valueGetter: (params) => {
      const pickupLocation = params.data?.locations?.find(
        (location) => location.type_of_loc === "PICKUP"
      );

      return pickupLocation && !_.isEmpty(pickupLocation.company_name)
        ? pickupLocation.company_name
        : "NA";
    },

    cellRenderer: (params) => {
      const pickupLocation = params.data?.locations?.find(
        (location) => location.type_of_loc === "PICKUP"
      );

      const pickupCompanyName =
        pickupLocation && !_.isEmpty(pickupLocation.company_name)
          ? pickupLocation.company_name
          : "NA";

      return <div>{pickupCompanyName}</div>;
    },
  };

  return companyNameColumn;
};


const getDeliveryColumnForPreplans = (navigateToAccount) => {
  const companyNameColumn = {
    headerName: "Company Name (D)",
    field: "company_name_delivery",
    isVisible: true,
    sortable: true,
    suppressMovable: true,
    floatingFilterComponentParams: { suppressFilterButton: true },

    valueGetter: (params) => {
      if (["T", "LH"].includes(params.data.type_of_order)) {
        const deliveryLocation = params.data?.locations?.find(
          (location) => location.type_of_loc === "DELIVERY"
        );

        return deliveryLocation && !_.isEmpty(deliveryLocation.company_name)
          ? deliveryLocation.company_name
          : "NA";
      } else {
        return _.get(params.data, "locations[0].company_name", "") || "";
      }
    },

    cellRenderer: (params) => {
      if (["T", "LH"].includes(params.data.type_of_order)) {
        const deliveryLocation = params.data?.locations?.find(
          (location) => location.type_of_loc === "DELIVERY"
        );

        const deliveryCompanyName =
          deliveryLocation && !_.isEmpty(deliveryLocation.company_name)
            ? deliveryLocation.company_name
            : "NA";

        return <div>{deliveryCompanyName}</div>;
      } else {
        return (
          <div>
            {_.get(params.data, "locations[0].company_name", "") || ""}
          </div>
        );
      }
    },
  };

  return companyNameColumn;
};

const renderLegCellForGrid = (params, locationType) => {
  const location = getPreplanLocationByType(params.data, locationType);
  if (!location) return null;
  return (
    <LegCell
      orderId={params.data.id}
      locationType={locationType}
      locationId={location.id}
    />
  );
};

const getLegWiseRowCheckboxColumn = () => ({
  key: "leg_row_checkbox",
  field: "leg_row_checkbox",
  width: 50,
  pinned: "left",
  suppressMenu: true,
  suppressMovable: true,
  suppressNavigable: true,
  suppressResize: true,
  filter: false,
  sortable: false,
  resizable: false,
  floatingFilter: false,
  headerComponent: () => <RowLegHeaderCheckboxCell />,
  cellRenderer: (params) => <RowLegCheckboxCell order={params.data} rowIndex={params.node.rowIndex} />,
});

const getPickupLegColumnForPreplan = () => ({
  headerName: "P",
  field: "pickup_leg",
  isVisible: true,
  lockVisible: true,
  sortable: false,
  pinned: "left",
  suppressMovable: true,
  filter: false,
  floatingFilter: false,
  suppressMenu: true,
  headerComponent: () => <LegHeaderCell locationType="PICKUP" />,
  valueGetter: (params) => {
    const pickupLocation = getPreplanLocationByType(params.data, "PICKUP");
    return pickupLocation ? getLegDisplayValue(pickupLocation, "PICKUP") : "NA";
  },
  cellRenderer: (params) => renderLegCellForGrid(params, "PICKUP"),
  cellStyle: { display: "flex", alignItems: "center", justifyContent: "center", padding: 0 },
  width: 60,
  minWidth: 60,
  suppressSizeToFit: true,
});

const getDeliveryLegColumnForPreplan = () => ({
  headerName: "D",
  field: "delivery_leg",
  isVisible: true,
  lockVisible: true,
  sortable: false,
  pinned: "left",
  suppressMovable: true,
  filter: false,
  floatingFilter: false,
  suppressMenu: true,
  headerComponent: () => <LegHeaderCell locationType="DELIVERY" />,
  valueGetter: (params) => {
    const deliveryLocation = getPreplanLocationByType(params.data, "DELIVERY");
    return deliveryLocation ? getLegDisplayValue(deliveryLocation, "DELIVERY") : "NA";
  },
  cellRenderer: (params) => renderLegCellForGrid(params, "DELIVERY"),
  cellStyle: { display: "flex", alignItems: "center", justifyContent: "center", padding: 0 },
  width: 60,
  minWidth: 60,
  suppressSizeToFit: true,
});


export const getTestColumn = () => {
  return [
    {
      headerName: "Company Name",
      marryChildren: true, // keeps columns together while dragging
      children: [
        {
          headerName: "Pickup",
          field: "pickup_company_name",
          sortable: true,
          valueGetter: (params) => params.data?.location[0]?.company_name || ""
        },
        {
          headerName: "Delivery",
          field: "delivery_company_name",
          sortable: true,
          valueGetter: (params) => params.data?.location[1]?.company_name || ""
        }
      ]
    }
  ];
};

export const getAccountCodeColumn = (navigateToAccount, screenFrom = "default", showLink = true) => {
  const accountCodeColumn = {
    headerName: 'Account Code',
    field: 'account_code',
    isVisible : true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params.data.account_code || '',
    cellRenderer: (params) => {
      const hasAccess = checkServiceExistance(['OPSAS', 'ACNF'], 'ALL') && showLink;
      const excludeFromScreens = ["preplan", "dispatch"];
      return (
        <div className="ellipsis-text">
          { hasAccess && !excludeFromScreens.includes(screenFrom) ? (
            <Link className={ hasAccess ? 'anchor_cursor' : '' } onClick={ () => { if (hasAccess) { navigateToAccount(params.data.account_code); } } }>
              { params.data.account_code }
            </Link>
          ) : params.data.account_code }
        </div>
      );
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 120,
  };
  return accountCodeColumn;
};

const accountLimitExceededColumn = {
  headerName: '',
  field: 'account_limit_exceeded',
  isVisible : true,
  cellRenderer: (params) => {
    const { account_limit_exceeded } = params.data;
    if (!account_limit_exceeded) {
      return null;
    }
    return (
      <div>
        <Tooltip title={ I18n.t("order.account_limit_exceeded") } placement="left">
          <Icon type="info-circle" style={ { color: "red" } } />
        </Tooltip>
      </div>
    );
  },
  filter: false,
  sortable: false,
  resizable: false,
  pinned: "right",
  suppressMenu: true,
  width: 48,
};


const getPreplanLosColumn = () => {
  const losColumn = {
    headerName: I18n.t('general.short_los'),
    field: "los",
    isVisible: true,
    filter: true,
    sortable: true,
    width: 120,
    valueGetter: (params) => {
      const data = params.data;
      if (["T", "LH"].includes(data.type_of_order)) {
        const pickup = data.locations.find(
          (loc) => loc.type_of_loc === "PICKUP"
        );
        const drop = data.locations.find(
          (loc) => loc.type_of_loc === "DELIVERY"
        );
        const pickupLOS = pickup?.los_code ? pickup?.los_code : "";
        const dropLOS = drop?.los_code ? drop.los_code : "";
        return `P: ${pickupLOS || 'None'} - D: ${dropLOS || 'None'}`;
      } else {
        return data.levelOfService || 'None';
      }
    },
    cellRenderer: (params) => {
      const data = params.data;
      if (["T", "LH"].includes(data.type_of_order)) {
        const pickup = data.locations.find(
          (loc) => loc.type_of_loc === "PICKUP"
        );
        const drop = data.locations.find(
          (loc) => loc.type_of_loc === "DELIVERY"
        );
        const pickupLOS = pickup?.los_code ? pickup?.los_code : "";
        const dropLOS = drop?.los_code ? drop.los_code : "";
      return (
          <>
            P: {pickupLOS || 'None'}
            &nbsp;-&nbsp;
            D: {dropLOS || 'None'}
          </>
        );
      } else {
        return data.levelOfService || 'None';
      }
    }
  };
  return losColumn;
};

const getPreplanActionColumn = (currentOrgCode) => {
  return {
    headerName: "",
    field: "preplan_order_actions",
    pinned: "right",
    cellRenderer: (params) => {
      const { data, rowIndex } = params;
      const index = rowIndex;
      const record = data;

      return (
        <div style={{ width: '100%', overflow: 'hidden' }}>
          <Row gutter={ 8 } type="flex" align="middle" justify="center">
            <Col span={ currentOrgCode === 'TA' ? 5 : 8 }>
              <PreplanOrderAccessorial
                record={ record }
                placement={
                  index !== 0 && index === params.data.length - 1
                    ? "topRight"
                    : "left"
                }
                showPopupContainer={ false }
              />
            </Col>
            <Col span={ currentOrgCode === 'TA' ? 5 : 8 }>
              <PreplanOrderNotes
                record={ record }
                placement={
                  index !== 0 && index === params.data.length - 1
                    ? "topRight"
                    : "left"
                }
                showPopupContainer={ false }
              />
            </Col>
            { currentOrgCode === 'TA' && (
              <>
                <Col span={ 5 } style={ { paddingTop: 2 } }>
                  <CustomerOrderDetails
                    order_no={ record.customer_order_number }
                    order={ {
                      id: record.id,
                      customer_order_number: record.customer_order_number,
                    } }
                    showEdit={ false }
                    showIcon={ true }
                    eyeIconStyle={ { fontSize: 15 } }
                  />
                </Col>
                <Col span={ 4 }>
                  <OrderAttachments
                    record={ record }
                    placement={
                      index !== 0 && index === params.data.length - 1
                        ? "topRight"
                        : "left"
                    }
                    showPopupContainer={ false }
                  />
                </Col>
              </>
            ) }
            { checkServiceExistance("NRURO") && (
              <Col span={ currentOrgCode === 'TA' ? 5 : 8 }>
                <div>
                  { record.account_limit_exceeded && (
                    <Tooltip
                      title={ I18n.t("order.account_limit_exceeded") }
                      placement="left"
                    >
                      <Icon type="info-circle" style={ { color: "red" } } />
                    </Tooltip>
                  ) }
                </div>
              </Col>
            ) }
          </Row>
        </div>
      );
    },
    width: currentOrgCode === 'TA' ? 120 : 90,
    filter: false,
    sortable: false,
    resizable: false,
  };
};

const preplanOrderActionColumns = {
  headerName: "",
  field: "preplan_order_actions",
  pinned: "right",
  cellRenderer: (params) => {
    const { data, rowIndex } = params;
    const index = rowIndex;
    const record = data;

    return (
      <div>
        <Row gutter={ 12 } type="flex">
          <Col span={ 5 }>
            <PreplanOrderAccessorial
              record={ record }
              placement={
                index !== 0 && index === params.data.length - 1
                  ? "topRight"
                  : "left"
              }
              showPopupContainer={ false }
            />
          </Col>
          <Col span={ 5 }>
            <PreplanOrderNotes
              record={ record }
              placement={
                index !== 0 && index === params.data.length - 1
                  ? "topRight"
                  : "left"
              }
              showPopupContainer={ false }
            />
          </Col>
          <Col span={ 5 } style={{ paddingTop: 2}}>
              <CustomerOrderDetails
                order_no={  record.customer_order_number }
                order={ {
                  id: record.id,
                  customer_order_number: record.customer_order_number,
                } }
                showEdit={ false }
                showIcon={true}
                eyeIconStyle={{ fontSize: 15 }}
              />
          </Col>
          <Col span={ 4 }>
            <OrderAttachments
              record={ record }
              placement={
                index !== 0 && index === params.data.length - 1
                  ? "topRight"
                  : "left"
              }
              showPopupContainer={ false }
            />
          </Col>
          { checkServiceExistance("NRURO") && (
            <Col span={ 5 }>
              <div>
                {record.account_limit_exceeded && (
                  <Tooltip
                    title={ I18n.t("order.account_limit_exceeded") }
                    placement="left"
                  >
                    <Icon type="info-circle" style={ { color: "red" } } />
                  </Tooltip>
                )}
              </div>
            </Col>
          ) }
          
        </Row>
      </div>
    );
  },
  width: 140,
  filter: false,
  sortable: false,
  resizable: false,
}


export const getAccountNameColumn = (navigateToAccount, screenFrom = "default", showLink = true) => {
  const accountNameColumn = {
    headerName: 'Account',
    field: 'account_name',
    isVisible: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params.data.account_name || '',
    cellRenderer: (params) => {
      const hasAccess = checkServiceExistance(['OPSAS', 'ACNF'], 'ALL') && showLink;
      const excludeFromScreens = ["preplan", "dispatch"];
      const accountName = params.data.account_name || '';
      //return hasAccess && !excludeFromScreens.includes(screenFrom) 
       // ? accountName 
        //: accountName;
        return hasAccess && !excludeFromScreens.includes(screenFrom) ? (
          <Link 
            className="anchor_cursor" 
            onClick={() => navigateToAccount(params.data.account_code)}
          >
            {accountName}
          </Link>
        ) : accountName;        
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 160,
  };

  return accountNameColumn;
};

const getAccountNameForMappedAccounts = (navigateToAccount) => {
  return {
    headerName: 'Account',
    field: 'name',
    valueGetter: (params) => params.data.name || '',
    cellRenderer: (params) => {
      const content = params.value;
      return (
        <Link
          className='anchor_cursor'
          onClick={() => { navigateToAccount(params.data.id) }}
        >
          {content}
        </Link>
      );
    },
    width: 400
  }
}

const getAccountCodeForMappedAccounts = (navigateToAccount) => {
  return {
    headerName: 'Account Code',
    field: 'code',
    valueGetter: (params) => params.data.code || '',
    cellRenderer: (params) => {
      const content = params.value;
      return (
        <Link
          className='anchor_cursor'
          onClick={() => { navigateToAccount(params.data.id) }}
        >
          {content}
        </Link>
      );
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 160,
  }
}

const getPhoneNumberForMappedAccounts = () => {
  return {
    headerName: 'Phone Number',
    field: 'phone_number',
    valueGetter: (params) => params.data.phone_number || '',
    cellStyle: {
      textAlign: 'left',
    },
    width: 150,
  }
}

const getAddressForMappedAccounts = () => {
  return {
    headerName: 'Address',
    field: 'address',
    valueGetter: (params) => {
      const { _id, coordinates, ...addressObj } = params.data?.address || {};

      if (!addressObj) return '';


      const filteredValues = Object.keys(addressObj)
        .sort()
        .map(key => addressObj[key])
        .filter(value => value && !_.isEmpty(value));

      return filteredValues.join(', ');
    },
    cellStyle: {
      textAlign: 'left',
    },
    cellRenderer: (params) => {
      const { _id, coordinates, ...addressObj } = params.data?.address || {};

      if (!addressObj) return <div>-</div>;

      const filteredValues = Object.keys(addressObj)
        .sort()
        .map(key => addressObj[key])
        .filter(value => value && !_.isEmpty(value));

      const addressString = filteredValues.join(', ');
      return (
        <Tooltip title={addressString}>
          <div>{addressString}</div>
        </Tooltip>
      );
    },
    width: 400,
  }
}

const getEmailForMappedAccounts = () => {
  return {
    headerName: 'Email',
    field: 'email',
    valueGetter: (params) => params.data.email || '',
    cellStyle: {
      textAlign: 'left',
    },
    cellRenderer: (params) => {
      return (
        <div>{params.value}</div>
      );
    },
    width: 250,
  }
}

const getContactPersonForMappedAccounts = () => {
  return {
    headerName: 'Contact Person',
    field: 'contact_person',
    valueGetter: (params) => params.data.contact_person || '',
    cellStyle: {
      textAlign: 'left',
    },
    cellRenderer: (params) => {
      return (
        <div>{params.value}</div>
      );
    },
    width: 200,
  }
}


const getAccessorialsCols = (props) => {
  const {editClick,cloneClick,deleteClick,doConfig,showDescription, readOnly, screenFrom, deleteLinkedClick, viewLinkedAccessorial, isMappingEnabled } = props;
  const AccessorialActionColumn = getAccessorialActionColumn(editClick,doConfig,cloneClick,deleteClick,readOnly,screenFrom,deleteLinkedClick, viewLinkedAccessorial)
  // const DescriptionColumn = descriptionCol(showDescription)
  const AccessorialCols = [
    ...(screenFrom === 'orgLevelMain' && isMappingEnabled !== false ? [checkboxColumn] : []),  
    getColumnName(screenFrom),
    getCodeColumn,
    getGlCodeColumn,
    getAccessibleToColumn,
    X12EdiCode,
    sources,
    AccessorialActionColumn
  ]
  return AccessorialCols
}

// Charted Accounts columns

const accountNameColumn = {
  headerName: 'Account Name',
  field: 'account_name',
  isVisible : true,
  resizable: false,
  valueGetter: (params) => params.data.account_name || '',
  cellRenderer : (params) => {
    if (!params.value) {
      return null;
    }
    return (
      <div>
        {params.value}
      </div>
    );
  }}

const accountNo = {
  headerName: 'Account No',
  field: 'account_number',
  isVisible : true,
  resizable: false,
  valueGetter: (params) => params.data.account_number || '',
  cellRenderer : (params) => {
    if (!params.value) {
      return null;
    }
    return (
      <div>
        {params.value}
      </div>
    );
  }
}

// const transactionType = {
//   headerName: 'Transcation Type',
//   field: 'transaction_type',
//   isVisible : true,
//   resizable: false,
//   width: 200,
//   valueGetter: (params) => params.data.transaction_type || '',
//   cellRenderer : (params) => {
//     if (!params.value) {
//       return null;
//     }
//     return (
//       <div>
//         {params.value}
//       </div>
//     );
//   }}

// const coaCategory = {
//   headerName: 'COA Category',
//   field: 'coa_category',
//   isVisible : true,
//   width: 200,
//   resizable: false,
//   valueGetter: (params) => params.data.coa_category || '',
//   cellRenderer : (params) => {
//     if (!params.value) {
//       return null;
//     }
//     return (
//       <div>
//         {params.value}
//       </div>
//     );
//   }
// }

const accountDesc = {
  headerName: 'Description',
  field: 'description',
  isVisible : true,
  resizable: false,
  width: 300,
  valueGetter: (params) => params.data.description || '',
  cellRenderer : (params) => {
    if (!params.value) {
      return null;
    }
    return (
      <div>
        {params.value}
      </div>
    );
  }};

// charted accounts columns ends here

const nameColumn = {
  headerName: 'Name',
  field: 'name',
  sortable: true,
  floatingFilter: true,
  filter: true,
  width: 200,
  suppressMenu: true,    
  cellRenderer: (params) => {
    const { value,data } = params;
    const is_Agent = data?.is_agent && data?.is_agent === "true" ? true : false; 
    if (!value) {
      return null;
    }
    return (
      // <Tooltip title={value}>
        <div>
          {value}&nbsp;
          {/* {fleetLite && */}
            {/* <Tooltip title="Agent">
              <sup className="textBold" style={{ fontSize: "100%",color: "blue", cursor: "pointer" }}>
                A
              </sup>
            </Tooltip> */}
            { is_Agent && <Tooltip title="Agent">
                <Tag color="blue">A</Tag>
              </Tooltip>}
          {/* } */}
        </div>
      // </Tooltip>
    );
  },
} 
const codeColumn = 
{
  headerName: 'Code',
  field: 'location_code',
  sortable: true, 
  width: 200,
  floatingFilter: true,
  filter: true,
  suppressMenu: true,    
}
const addColumn = 
{
  headerName: 'Address',
  field: 'l_address',
  width: 400,
  sortable:false,
  filter : false,
  suppressMenu: true,    
  cellRenderer: (params) => {
    const { _id, ...addressValues } = params.value;
    const address = Object.values(addressValues).join(', ');
    return (
      <Tooltip title={address}>
        <div>{address}</div>
      </Tooltip>
    );
  },
}

const emailCol = {
  headerName: 'Email',
  field: 'email',
  sortable: true,
  width: 200,
  suppressMenu: true,    
  valueGetter: (params) => params.data.email,
  floatingFilter: true,
  filter: true,
  cellRenderer: (params) => {
    const { value } = params;
    if (!value) {
      return null;
    }
    return (
      <Tooltip title={value}>
        <div>{value}</div>
      </Tooltip>
    );
  },
}
const contactNameColumn = {
  headerName: 'Contact Name',
  field: 'first_name',
  sortable: true,
  width: 200,
  suppressMenu: true,    
  floatingFilter: true,
  valueFormatter: (params) => { formatFullName(params.value); },
  filter: true,
}


const contactCol = { headerName: 'Phone',
  field: 'phone',
  sortable: true, 
  floatingFilter: true, 
  filter: true,
  suppressMenu: true,    
 }
 const trackLinkColumn = {
  headerName: I18n.t("location.track_link"),
  field: "link",
  width: 200,
  sortable: true,
  suppressMenu: true,    
  valueGetter: (params) => {
    const organization_id = userStore.getStateValue("selectedOrg");
    return `${window.location.origin}/drivers_tracking/track_driver?organization_id=${userStore.getStateValue(
      "selectedOrg"
    )}&location_code=${params.data.location_code}`;
  },
  floatingFilter: true,
  filter: false,
  width: 200,
  cellRenderer: TrackLinkRenderer,
  cellRendererParams: {
    tooltipText: I18n.t("location.track_link"),
    color: "#1890ff",
    showTooltip: true,
  },
}

const getDelivery = (showDeliveryZones) => {
 const deliveryZonesCol = {
  headerName: I18n.t("location.delivery_zones"),
  field: "zones",
  width: 200,
  sortable: false,
  floatingFilter: false,
  filter: false,
  suppressMenu: true,    
  cellRenderer: (id,params) => (
    <span>
      {checkServiceExistance("DZI") && (
        <Tooltip title="Click to manage Delivery Zones">
          <Icon type="global" onClick={() => showDeliveryZones(id)} />
        </Tooltip>
      )}
    </span>
  ),
}
return deliveryZonesCol
}
const getAcctionCols = (handleEditClick,deleteClick,isSuperAdmin=false,required=true) => {
const actionCol = {
  headerName: 'Actions',
  field: 'id',
  sortable: false,
  floatingFilter: false,
  pinned: "right",
  width: 100,
  suppressMenu: true,
  resizable: required,
  cellRenderer: (params) => (
    <div className='line-actions' style={{ width: '100%' }}>
      <Row type="flex" align="middle">
        <Col>
          {checkServiceExistance('AU') && (
            <Tooltip title={I18n.t("general.edit")}>
              <span>
                <EditIcon handleClick={()=> handleEditClick(params)}/>
              </span>
            </Tooltip>
          )}
        </Col>
        <Col>
          {!isSuperAdmin && checkServiceExistance('AD') && (
            <Tooltip title={I18n.t("general.delete")}>
              <Popconfirm
                placement="left"
                title={I18n.t('messages.delete_confirm')}
                onConfirm={() => deleteClick(params)}
                okText="Yes"
                cancelText="No"
              >
                <span><DeleteIcon /></span>
              </Popconfirm>
            </Tooltip>
          )}
        </Col>
      </Row>
    </div >
  )

}
return actionCol
}

const getQuoteAcctionCols = (handleEditClick, deleteClick, cloneClick, validateQuoteClick, revertQuote, showReviews, showZips, isSuperAdmin) => {
  const actionCol = {
    headerName: '',
    field: 'id',
    sortable: false,
    floatingFilter: false,
    pinned: "right",
    width: 150,
    suppressMenu: true,
    resizable: false,
    cellRenderer: (record) => {
      const {data} = record
      return( 
        <>
      <div className='line-actions' style={{ width: '100%' }}>
        <Row type="flex" align="middle">
        {!['APPROVED', 'REJECTED', "EXPIRED"].includes(data.status) &&
              checkServiceExistance('QU') ? (
                <>
                <Col>
                  <Tooltip title={I18n.t("order.clone")}>
                    <Icon
                      type="snippets"
                      onClick={() => cloneClick(data.id)}
                      className="SnippetsIcon"
                    />
                  </Tooltip>
                </Col>
                
                <Col>
                  <Tooltip title={I18n.t('general.edit')}>
                    <EditIcon handleClick={()=> handleEditClick(data)}/>
                    &nbsp;
                  </Tooltip>
                </Col>
                </>
              ) : (
                ''
              )}
              {!isEmpty(data.quote_amount) && (
                <Col>
                  {data.status === 'PENDING' && checkServiceExistance('QTO') && (
                    <Fragment>
                      <Popconfirm
                        placement="left"
                        title={I18n.t('messages.action_confirm', {
                          action: 'approve',
                          field: 'this',
                        })}
                        onConfirm={() => validateQuoteClick(data.id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Tooltip title={I18n.t('general.approve')}>
                          <Icon
                            type="check-circle"
                            className="cursorPointer textGreen"
                          />
                        </Tooltip>
                      </Popconfirm>
                    </Fragment>
                  )}
                </Col>
              )}
              {data.status === 'PENDING' && checkServiceExistance('QD') && (
                <Col>
                  <Popconfirm
                    placement="left"
                    title={I18n.t('messages.action_confirm', {
                      action: 'reject',
                      field: 'this',
                    })}
                    onConfirm={() => deleteClick(data.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Tooltip title={I18n.t('general.reject')}>
                  <Icon
                        type="close-circle"
                        className="cursorPointer textRed"
                      />
                      &nbsp;&nbsp;&nbsp;
                    </Tooltip>
                  </Popconfirm>
                </Col>
              )}
              {
                data.status === "APPROVED" &&
                <Col>
                    <Tooltip title="Revert">
                      <RevertIconFilled
                        className="cursorPointer"
                        onClick={() => revertQuote(data.id, data.orders)}
                      />
                      &nbsp;&nbsp;&nbsp;
                    </Tooltip>

                </Col>

              }

            </Row>
      </div >
        </>
      )
  }
  
  }
  return actionCol
}

const getSubOrdersActionColumns = (handleEditClick) => {
  const actionCol = {
    headerName: '',
    field: 'id',
    sortable: false,
    floatingFilter: false,
    pinned: "right",
    width: 150,
    suppressMenu: true,
    cellRenderer: (record) => {      
      const { data } = record;
      return (
        <div className='line-actions' style={{ width: '100%' }}>   
          <Row type="flex" align="middle">
            <Col> 
              <Button_v2
              key="cancel"
              text="De-LInk"
              className="flat medium-btn"
              onClick={()=> handleEditClick(data,'delink')}
             
            />
            </Col>
           
          </Row>
        </div>
      );
    }
  };
  return actionCol
}
const getPendingOrdersActionColumns = (handleBillOfRating) => {
  const actionCol = {
    headerName: '',
    field: 'id',
    sortable: false,
    floatingFilter: false,
    pinned: "right",
    width: 150,
    suppressMenu: true,
    cellRenderer: (record) => {
      const { data } = record;
      return (
        <div>

          {checkServiceExistance("OBLR") && (
            <Tooltip
              title={I18n.t("BillOfRating.bill_of_rating_title")}
              placement="left"
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              overlayStyle={{ marginRight: 30 }}
            >
              <Icon
                type="file-done"
                className="billOfLadingIcon"
                onClick={() => handleBillOfRating(data.id, data.customer_order_number.data.type_of_order)}
              />
            </Tooltip>
          )}
        </div>
      );
    }
  };
   return actionCol
}
const getQuoteMawbColumn = (showQuoteDetails) => {
  const quoteMawbColumn = {
    headerName: 'MAWB',
    field: 'mawb',
    isVisible: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params.data.mawb || '',
    cellRenderer: (params) => {
      return params.data.mawb 
        ? setQuoteLinkColumn(params.data.mawb, params.data, showQuoteDetails, true)
        : '';
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 160,
  };
  return quoteMawbColumn;
};
const getSubOrderHawbColumn = () => {
  const quoteHawbColumn = {
    headerName: 'HAWB',
    field: 'Hawb',
    isVisible: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params.data.Hawb || '',
    cellRenderer: (params) => {
      return params.data.Hawb 
        ? params.data.Hawb
        : '';
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 160,
  };
  return quoteHawbColumn;
};
const getQuoteHawbColumn = (showQuoteDetails) => {
  const quoteHawbColumn = {
    headerName: 'HAWB',
    field: 'hawb',
    isVisible: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params.data.hawb || '',
    cellRenderer: (params) => {
      return params.data.hawb 
        ? setQuoteLinkColumn(params.data.hawb, params.data, showQuoteDetails, true)
        : '';
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 160,
  };
  return quoteHawbColumn;
};
const getQuoteNumberColumn = (showQuoteDetails) => {
  const quoteNumberColumn = {
    headerName: I18n.t('quotes.quote_no'),
    field: 'quote_no',
    isVisible: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params?.data?.quote_order_number || '',
    cellRenderer: (params) => {
      return params?.data?.quote_order_number 
        ? setQuoteLinkColumn(params?.data?.quote_order_number, params?.data, showQuoteDetails, true)
        : '';
    },
    cellStyle: {

      textAlign: 'left',
    },
    width: 160,
  };
  return quoteNumberColumn;
};

const getQuoteEstimateColumn = (showQuoteDetails) => {
  const quoteEstimateColumn = {
    headerName: I18n.t('order.quote'),
    field: 'quote',
    isVisible: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => params.data.quote_amount || '',
    cellRenderer: (params) => {
      return params.data.quote_amount 
        ? setLinkEstimateColumn(params.data.quote_amount, params.data, showQuoteDetails, true)
        : '';
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 160,
  };
  return quoteEstimateColumn;
};

const quoteCreationSourceColumn = {
  headerName: 'Source',
  field: "source",
  isVisible: true,
  sortable: true,
  valueGetter: (params) => {
    const { source, created_by_id } = params.data || {};
    if (source) return source;
    if (!source && created_by_id) return "FLEET";
    return "";
  },
  width: 160,
};

const createdByUsernameColumn = {
  headerName: "Created By Username",
  field: "created_by_username",
  isVisible: true,
  sortable: true,
  valueGetter: (params) => params.data.created_by_username || '',
  width: 160,
};

const getQuotesCols = (props) => {
  const { handleEditClick, deleteClick, cloneClick, validateQuoteClick, showReviews, showZips, isSuperAdmin, navigateToAccount, showQuoteDetails = true, accountWeightUnits, revertQuote, isCLIEnabled = false } = props;
  const actionQuoteColumns = getQuoteAcctionCols(handleEditClick, deleteClick, cloneClick, validateQuoteClick, revertQuote, showReviews, showZips, isSuperAdmin)
  const quoteHawbColumn = getQuoteHawbColumn(showQuoteDetails);
  const quoteMawbColumn = getQuoteMawbColumn(showQuoteDetails);
  const accountNameColumn = getAccountNameColumn(navigateToAccount, 'quotes');
  const accountCodeColumn= getAccountCodeColumn(navigateToAccount, 'quotes');
  const quoteNumberColumn = getQuoteNumberColumn(showQuoteDetails);
  const quoteEstimateColumn = getQuoteEstimateColumn(showQuoteDetails);
  const WeightColumnDynamicUnits = getCombinedWeightunits(weightColumn, Number(_.get(props.userContext, "orgRules.org_billing_rules.round_off_decimals","2")));
  const quoteCols = [
    quoteNumberColumn,
    quoteHawbColumn,
    quoteMawbColumn,
    typeColumn(isCLIEnabled),
    quoteExpiryDateColumn('Quote Date','quote_date'),
    QuotesOriginDestinationColumn,
    accountNameColumn,
    accountCodeColumn,
    quoteExpiryDateColumn('Expiry Date','expiry_date'),
    quoteCreationSourceColumn,
    WeightColumnDynamicUnits,
    losColumn('los'),
    quoteEstimateColumn,
    createdByUsernameColumn,
    quoteStatusCol,
    lastUpdatedByColumn,
    actionQuoteColumns,
    
  ]
  return quoteCols
  
}
const getSubOrderCols = (props) => { 
  const {handleEditClick
    // cloneClick,validateQuoteClick,showReviews,showZips,isSuperAdmin,navigateToAccount,showQuoteDetails=true, accountWeightUnits
  } = props;
  const actionSubOrdersColumns  = getSubOrdersActionColumns(
    handleEditClick
    // cloneClick,validateQuoteClick,showReviews,showZips,isSuperAdmin

  )
  const orderNoColumn = getSubOrdersOrderNoColumn(
    // showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink
  );
  const subOrderHawbColumn = getSubOrderHawbColumn();  
  // const WeightColumnDynamicUnits = getCombinedWeightunits(weightColumn, Number(_.get(props.userContext, "orgRules.org_billing_rules.round_off_decimals","2")));
  const subOrderCols = [
    orderNoColumn,
    subOrderHawbColumn,
    // typeColumn,,
    consolidatedTypeColumn,
    // QuotesOriginDestinationColumn,
    originDestinationColumn(),
    weightColumn,
    statusColumn,
    quantitySubordersColumn,
    readyForBillingColumn,
    invoiceColumn,
    actionSubOrdersColumns,
  ]  
  return subOrderCols
  
}

const getPendingOrdersCols = (props) => {
  const { showEditIcon = true, showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink, hideAppointmentdate, organizationSettings, navigateToAccount, resolvedAddressCallback, handleBillOfRating, accountWeightUnits, isCLIEnabled = false } = props;
  const actionPendingOrdersColumns  = getPendingOrdersActionColumns(handleBillOfRating)
  const orderNoColumn = getPendingOrderNoColumn(showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink);
  const companyNameColumn = getCompanyNameColumn(navigateToAccount);
  const appointmentsColumn = getAppointmentsColumn(hideAppointmentdate, organizationSettings);  
  const zipcodeColumn = getZipcodeColumn(resolvedAddressCallback);
  const accountNameColumn = getAccountNameColumn(navigateToAccount,);
  const accountCodeColumn= getAccountCodeColumn(navigateToAccount,);
  const hawbColumn = getHawbColumn(showTriggerEdit, handleEditOrder, refreshCallback, showEditIcon);
  const mawbColumn = getMawbColumn(showTriggerEdit, handleEditOrder, refreshCallback, showEditIcon);
  const reference1Column = getReferenceColumn(showTriggerEdit, handleEditOrder, refreshCallback, 'reference_1', showEditIcon);
  const reference2Column = getReferenceColumn(showTriggerEdit, handleEditOrder, refreshCallback, 'reference_2', showEditIcon);
  const consigneeColumn = getCustomerNameColumn()
  const WeightColumnDynamicUnits = getCombinedWeightunits(weightColumn, Number(props.organizationSettings.round_off_decimals));
  // const vehicleTypeColumn = getVehicleTypeColumn(vhTypes);

  const pendingOrdersCols = [
       checkboxColumn,
       orderNoColumn,
       pendingOrdersStreetColumn(),
       cityColumn(),
       warehouseColumn,
       routingColumn,
       statusColumn,
       companyNameColumn,
       pendingOrdersSource,
       getAddressColumn(),
       typeColumn(isCLIEnabled),
       appointmentsColumn,
       consigneeColumn,
       zipcodeColumn,
       originDestinationColumn(),
       accountNameColumn,
       accountCodeColumn,
       age,
       quantityColumn,
       WeightColumnDynamicUnits,
       losColumn('los'),
       zonesColumn,
       hawbColumn,
       mawbColumn,
       reference1Column,
       reference2Column,
       vehicleTypeColumn,
       actionPendingOrdersColumns,
    
  ]
  return pendingOrdersCols
}
const setQuoteLinkColumn = (data, record, showQuoteDetails, showEllipsisText = true) => {
  return (
    <Row type="flex" style={{ flexFlow: "unset" }} gutter={4} align="middle">
      <Col>
        <span
          className="anchor_cursor"
          onClick={() => {
            showQuoteDetails(record
            );
          }}
        >
          {showEllipsisText ? <Tooltip title={data}>{data}</Tooltip> : data}
        </span>
      </Col>
      {data  && (
        <Col>
          <Copyable text={data} />
        </Col>
      )}
    </Row>
  );
};
const setLinkEstimateColumn = (data, record, showQuoteDetails, showEllipsisText = true) => {
  return (
    <Row type="flex" style={{ flexFlow: "unset" }} gutter={4} align="middle">
      <Col>
        <span
          // className="anchor_cursor"
          // onClick={() => {
          //   showQuoteDetails(record.id
          //   );
          // }}
        >
          
          {showEllipsisText ? <Tooltip title={'Quote Amount'}>$ &nbsp;{data}</Tooltip> : data}
        </span>
      </Col>
      {/* {data  && (
        <Col>
          <Copyable text={data} />
        </Col>
      )} */}
    </Row>
  );
};
const OrdersActionCols = (
  statusChange,
  handleEditOrder,
  handleBillOfRating,
  navigateToRoute,
  generateInvoice,
  handleSurveyDetails,
  currentFilter,
  screen_from,
  moveToPending,
  accountCodesWithExceededLimit,
  props
) => {
  const hasRoutesAccess = checkAccessExistance("DISPATCH");
  const currentOrg = props.currentOrg;
  const incomingOrgId = _.get(currentOrg, "code", null);
  const hillLogisticsOrgId = "HILL";
  const showActions = props.showActions !== false;
  const nonBillableAccountCodes = props.nonBillableAccountCodes || [];
  const getActionCols = {
    headerName: "",
    headerComponent: () =>{ 
      return (
    <div className="alignRight" style={{width:"100%"}} onClick={()=>{props.toggleRearrangeableModal()}}> 
    <EditRearrangableIcon />
    </div>
  )},
    headerComponentParams: {
      styling: { cursor: "pointer" },
      onClick: () => {
        props.toggleRearrangeableModal()
      }
    },
    field: "id",
    sortable: false,
    resizable: false,
    floatingFilter: false,
    pinned: "right",
    width: 160,
    cellRenderer: (id, params) => {
      const verifyManualBol =
        _.get(id.data, "type_of_order", null) !== "T"
          ? _.get(id.data, "bol_picture", null)
          : {
              origin: _.get(id.data, "bol_picture", null),
              destination: _.get(id.data, "delivery_bol_picture", null),
            };
      const isVerifyManualBolValid = verifyManualBol
        ? typeof verifyManualBol === "object"
          ? Object.values(verifyManualBol).some((value) => !!value)
          : !_.isEmpty(verifyManualBol)
        : false;
      return (
        <div
          className={
            currentFilter === "" ||
            currentFilter === "COMPLETED" ||
            currentFilter === "EXCEPTION"
              ? "alignLeft table-action-btns"
              : "alignCenter table-action-btns"
          }
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div style={{ width: "30px" }}>
            {accountCodesWithExceededLimit.includes(id.data.account_code) ? (
              <Tooltip
                title={I18n.t("order.account_limit_exceeded")}
                placement="left"
              >
                <Icon type="info-circle" style={{ color: "red" }} />
              </Tooltip>
            ) : null}
          </div>
          {showActions && <div style={{ width: "30px" }}>
            {checkServiceExistance("COSU") &&
              !["PENDING", "REJECTED"].includes(id.data.status) && (
                <Tooltip
                  title={I18n.t("tooltip.change_status")}
                  placement="topLeft"
                  overlayStyle={{ marginRight: 30 }}
                >
                  <SettingIcon handleClick={() => statusChange(id.data.id, id.data)} />  
                  {/* {SettingIconSvg} */}
                </Tooltip>
              )}
          </div>}
          { showActions &&  <div style={{ width: "30px" }}>
            {![
              "INTRANSIT",
              "PICKEDUP",
              "CLOSED",
              "ARCHIVED",
              "PENDING",
              "REJECTED",
            ].includes(id.data.status) &&
              checkServiceExistance("SCA") &&
              (isEmpty(id.data.is_locked) ||  id.data.is_locked === "false" ? (
                <Tooltip title={I18n.t("tooltip.edit")} placement="topLeft">
                  <EditIconSvg
                    onClick={() => {
                      handleEditOrder(id.data.id),
                        localStorage.setItem("orders-beta", false);
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip title={I18n.t("invoices.locked")} placement="topLeft">
                  <img
                    src={lock}
                    className="expandIcon cursorPointer"
                    alt={I18n.t("invoices.locked")}
                    style={{ height: 12, width: 12, color: "#576EC1" }}
                  />
                </Tooltip>
              ))}
          </div>}
          <div style={{ width: "30px" }}>
            {checkServiceExistance("OBLR") && (
              <Tooltip
                title={I18n.t("BillOfRating.bill_of_rating_title")}
                placement="topLeft"
                overlayStyle={{ marginRight: 30 }}
              >
                <BolIcon
                  onClick={() =>
                    handleBillOfRating(
                      id.data.id,
                      id.data.customer_order_number,
                      id.data.type_of_order
                    )
                  }
                />
              </Tooltip>
            )}
          </div>
          {showActions &&  <div style={{ width: "30px" }}>
            {screen_from !== "routes" &&
              id.data.nav_route_status &&
              id.data.nav_route_name && (
                <Tooltip
                  title={
                    id.data.nav_route_status
                      ? `${id.data.nav_route_status} - ${id.data.nav_route_name}`
                      : I18n.t("menu.routes")
                  }
                  placement="left"
                  overlayStyle={{
                    width: 250,
                    maxWidth: "400px",
                    marginRight: "150px",
                  }}
                  mouseEnterDelay={AppConfig.tooltipDelay}
                >
                <RouteIcon
                  onClick={() =>
                      hasRoutesAccess
                        ? navigateToRoute(
                            id.data.nav_route_id,
                            id.data.nav_route_status,
                            id.data.scheduled_start_datetime_with_tz
                          )
                        : null
                    }
                  />
                </Tooltip>
              )}
          </div>
          }
          { showActions && id.data.status === "COMPLETED" && (
            <>
              <div style={{ width: "30px" }}>
                {checkServiceExistance("COB") &&
                  !nonBillableAccountCodes.includes(id.data.account_code) && (
                  <Tooltip
                    title="Starting billing process"
                    placement="left"
                    overlayStyle={{
                      width: 180,
                      maxWidth: "300px",
                      marginRight: "100px",
                    }}
                    mouseEnterDelay={AppConfig.tooltipDelay}
                  >
                    <BillingSettingsIcon
                      type="file-pdf"
                      style={{ color: "#7c1034" }}
                      onClick={() => generateInvoice(id.data.id, "false")}
                    />
                  </Tooltip>
                )}
              </div>
              <div style={{ width: "30px" }}>
                <Tooltip
                  title={I18n.t("survey.view_submitted")}
                  placement="left"
                  mouseEnterDelay={AppConfig.tooltipDelay}
                  overlayStyle={{
                    width: 200,
                    maxWidth: "300px",
                    marginRight: "100px",
                  }}
                >
                  <SurveyForm
                    onClick={() => handleSurveyDetails(id.data.id)}
                  />
                </Tooltip>
              </div>
            </>
          )}
          <div style={{ width: "30px" }}>
            {incomingOrgId === hillLogisticsOrgId && isVerifyManualBolValid && (
              <ManualBolViewer
                verifyManualBol={verifyManualBol}
                manualBol={manualBol}
                key="manualBol"
                title={id.data}
                height={"13px"}
                width={"13px"}
              />
            )}
          </div>
        </div>
      );
    },
  };
  return getActionCols;
};


const getWarehouseCols = (props) => {
  const {editClick,deleteClick,showReviews,showZips,showDeliveryZones,isSuperAdmin} = props;
  const actionWarehouseColumns  = getAcctionCols(editClick,deleteClick,showReviews,showZips,isSuperAdmin)
  const getDeliveryZonesColumns= getDelivery(showDeliveryZones)
  // const getTrackLinkColumns = getTrackLink()
  const warehouseCols = [
    nameColumn,
    codeColumn,
    addColumn,
    emailCol,
    contactCol,
    contactNameColumn,
    trackLinkColumn,
    getDeliveryZonesColumns,
    actionWarehouseColumns
  ]
  return warehouseCols
}



const getColumnName = (screenFrom) => {
  return {
    headerName: "Name",
    field: "name",
    valueGetter: (params) => params.data.accessorial_name,

    cellRenderer: (params) => {
      const hasOrgAccessorial = !isEmpty(params?.data?.organization_accessorial_id);

      const accessorialIconRender = hasOrgAccessorial
        ? <OrgLevelAccIcon width={"16"} height={"16"}/>
        : screenFrom === "accountLevel"
        ? <AccLevelAccIcon width={"16"} height={"16"}/>
        : <MasterLevelAccIcon width={"16"} height={"16"}/>;
      
      const accessorialAltText = hasOrgAccessorial ? "Organization Accessorial" : screenFrom === "accountLevel" ? "Account Accessorial" : "Rate Sheet Accessorial";
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {screenFrom !== "orgLevelMain" && accessorialIconRender}
          <span>{params.data.accessorial_name}</span>
        </div>
      );
    }
  };
};

const getCodeColumn = {
  headerName : "Code",
  field :'code',
  valueGetter : (params => params.data.accessorial_code),
  width: 160,
}
const getGlCodeColumn = {
  headerName : "GL Code",
  field :'gl_code',
  valueGetter : (params => params.data.gl_code),
  width: 160,
}

const getAccessibleToColumn = {
  headerName : "Accessible To",
  field :'accessible_to',
  valueGetter : (params => params.data.accessible_to),
  width: 160,
}
//   const  descriptionCol = (showDescription)=> {
//     if(showDescription !== false) {
//       const getDescriptionColumn = {
//         headerName : "Description",
//         field :'description',
//         valueGetter : (params => params.data.description),
//         width: 160, 
//       }
//       return getDescriptionColumn;
//     }
// }

const X12EdiCode = {
  headerName : "X12 Edi Code",
  field :'edi_code',
  valueGetter : (params => params.data.x12_code),
  width: 160,
}

const DeliverByColumn = {
  headerName : I18n.t("general.deliver_by"),
  field :'deliver_by',
  isVisible : true,
  sortable: true,
  filter: true,
  valueGetter: (params) => {
    return params.data.delivery_by;
  },
  cellRenderer: (params) => {
    const record = params.data;
    const displayTime = record.order_label === "R" ? record.pickup_by : record.delivery_by;
    const tzShortName = record?.tz_short_form
    //destination 
    const destTimeZoneId = record.destinationTimeZoneId || record.timeZoneId || "";
    const destTZShortForm = record.destinationTzShortForm || tzShortName || "" ;
    return (
      <div style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: 1,
      }}>
        {displayTime ? (
          <>
            <DisplayTime
              dateTimeString={displayTime}
              displayWithDate={true}
              dateTimeFormat={AppConfig.dateTimeFormat}
              isUTC={true}
              timeZoneId={destTimeZoneId}
            />{" "}
            {destTZShortForm}
          </>
        ) : (
          "NA"
        )}
      </div>
    );
  },
  width: 130,
};

const CitiesColumn = {
  headerName : "City",
  field :'cities',
  isVisible : true,
  sortable: true,
  filter: true,
  valueGetter: (params) => {
    const record = params.data;
    if (record.type_of_order === "T") {
      return `P: ${record.origin?.city || 'NA'} - D: ${record.destination?.city || 'NA'}`;
    } else {
      return record.customer_city || '';
    }
  },
  cellRenderer: (params) => {
    const record = params.data;
    if (record.type_of_order === "T") {
      return `P: ${record.origin?.city || 'NA'} - D: ${record.destination?.city || 'NA'}`;
    } else {
      return record.customer_city || '';
    }
    
  },
  width: 180,
};



const sources = {
  headerName : "Sources",
  field :'sources',
  valueGetter: (params) => {
    return params.data.components ? 
    params.data.components.map((data) => data.component_name).join(', ') : 
    ''
  },
  width: 200,
}

const pendingOrdersSource = {
  headerName : "Source",
  field :'source',
  isVisible : true,
  valueGetter: (params) => {
    return params.data.source 
    // ? 
    // params.data.components.map((data) => data.component_name).join(', ') : 
    // ''
  },
  width: 200,
}


const getAccessorialActionColumn = (editClick,doConfig,cloneClick,deleteClick,readOnly,screenFrom,deleteLinkedClick, viewLinkedAccessorial ) => {
  const actionColumns = {
    headerName : 'Actions',
    field: 'id',
    sortable :false,
    pinned : 'right',
    width: 140,
    floatingFilter : false,
    cellRenderer : (id,params) => (
      <div className='line-actions' style={{
        width: '100%',
      }} >
        <Row type="flex" align="middle">
  
          <Col >
          {
                checkServiceExistance(['AAAAD', 'AACAA', 'AAAC'], 'ALL') && 
                <Tooltip title={readOnly ? "View Configuration": I18n.t("tooltip.setting") }>
              <SettingIcon handleClick={() => doConfig(id.data.id)}/>
              &nbsp;
              </Tooltip>
              }
              &nbsp;
          </Col>
          {!readOnly && <Col >
              <Tooltip
                title ={ I18n.t("general.edit") }
                placement="left"
              >
                <EditIcon handleClick={() => editClick(id.data.id)}/>
              </Tooltip>
          </Col>}
  
          {!readOnly && <Col >
          {checkServiceExistance('AAAACL') && !isEmpty(id?.data?.standard_code) && id?.data?.is_clone == 'false' && (
                <Tooltip title={ I18n.t("tooltip.copy") }>
                <Icon
                  type="copy"
                  onClick={() => cloneClick(id.data.id)}
                />
                </Tooltip>
              )}
          </Col>}
  
          {!readOnly &&<Col >
          {checkServiceExistance('AAD') && (!id?.data?.standard_code || 
              (id?.data?.standard_code && id.data.is_clone == 'true')) 
              && (
                screenFrom !== "orgLevelMain" ? (
                <Tooltip title={ I18n.t("general.delete") }>
                <Popconfirm
                  placement="left"
                  title={I18n.t("messages.delete_confirm")}
                  onConfirm={() => deleteClick(id.data.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteIcon/>
                  &nbsp;&nbsp;&nbsp;
                </Popconfirm>
                </Tooltip>) : (
                  <DeleteActionPopover
                    onDelete={() => deleteClick(id.data.id)}
                    onDeleteLinked={() => deleteLinkedClick(id.data.id)}
                  />)
              )}
          </Col>}
          { screenFrom === "orgLevelMain" && <Col>
            <Tooltip title={"View Linked"}>
              <Icon
                type="eye"
                onClick={() => viewLinkedAccessorial(id.data)}
              />
            </Tooltip>
          </Col>}
        </Row>
      </div >
    )
  }
  return actionColumns;
  }


const getPreplanQuantityColumn = (quantityColumn, isMilitaryTime, setIsItemVisible) => {

  const modifiedColumn = {
    ...quantityColumn,
    cellRenderer: (params) =>
      params.data.quantity ? (
        <OrderQuantity
          record={params.data}
          key={`unm${params.data.id}`}
          keyId={`un${params.data.id}`}
          showActions={true}
          isMilitaryTime={isMilitaryTime}
          setIsItemVisible={setIsItemVisible}
        >
          {params.data.quantity}
        </OrderQuantity>
      ) : (
        ""
      ),
  }

  return modifiedColumn;

}

  const getReference1NoColumn = (showTriggerEdit,showDetailsLink, handleEditOrder,gotoOrderDetails) => {
    const reference1Column = {
      headerName: 'Reference 1',
      field: 'reference_1',
      isVisible : true,
      cellRenderer: (params) => {
        return (
          <Col>
                  {showTriggerEdit ? (
                    <Link onClick={() => handleEditOrder(params.data.id)}>
                      {<OrderFieldDisplay data={ params.data  } toDisplay="reference_1" charsToLimit={ null } />}
                    </Link>
                  ) : showDetailsLink !== false ? (
                    <Link onClick={() => gotoOrderDetails(params.data.id)}>
                      {<OrderFieldDisplay data={ params.data  } toDisplay="reference_1" charsToLimit={ null } />}

                    </Link>
                  ) : (
                    <></>
                  )}
                </Col>
        )
      },
      width: 140,
    };
    return reference1Column;
  }; 
  
  const getReference2NoColumn = (showTriggerEdit,showDetailsLink, handleEditOrder,gotoOrderDetails) => {
    const reference2Column = {
      headerName: 'Reference 2',
      field: 'reference_2',
      isVisible : true,
      cellRenderer: (params) => {
        return (
          <Col>
                  {showTriggerEdit ? (
                    <Link onClick={() => handleEditOrder(params.data.id)}>
                      {<OrderFieldDisplay data={ params.data  } toDisplay="reference_2" charsToLimit={ null } />}
                    </Link>
                  ) : showDetailsLink !== false ? (
                    <Link onClick={() => gotoOrderDetails(params.data.id)}>
                      {<OrderFieldDisplay data={ params.data  } toDisplay="reference_2" charsToLimit={ null } />}

                    </Link>
                  ) : (
                    <></>
                  )}
                </Col>
        )
      },
      width: 140,
    };
    return reference2Column;
  };

const getDispatchCols = (props) => {
  // destructuring props
  const { 
    showTriggerEdit,
    handleEditOrder,
    refreshCallback,
    showDetailsLink,
    hideAppointmentdate,
    vhTypes,
    organizationSettings,
    resolvedAddressCallback,
    navigateToAccount,
    statusColorContext,
    isCLIEnabled = false
  } = props;
  const orderNoColumn = getOrderNoPreplanColumn(showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink, null, true, statusColorContext);
  const hawbColumn = getHawbColumn(showTriggerEdit, handleEditOrder, refreshCallback);
  const mawbColumn = getMawbColumn(showTriggerEdit, handleEditOrder, refreshCallback);
  const appointmentsColumn = getAppointmentsColumn(hideAppointmentdate, organizationSettings);  
  const vehicleTypeColumn = getVehicleTypeColumn(vhTypes);
  const vehicleImageColumn = getVehicleImageColumn(vhTypes);
  const zipcodeColumn = getZipcodeColumn(resolvedAddressCallback);
  const companyNameColumn = getCompanyNameColumn(navigateToAccount);
  const accountCodeColumn = getAccountCodeColumn(navigateToAccount);
  const accountNameColumn = getAccountNameColumn(navigateToAccount);
  const customerNameColumn = getCustomerNameColumn();
  const reference1Column = getReferenceColumn(showTriggerEdit, handleEditOrder, refreshCallback, 'reference_1');
  const reference2Column = getReferenceColumn(showTriggerEdit, handleEditOrder, refreshCallback, 'reference_2');
  const tagsColumns = getTagsColumn();
  const dispatchCols = [
    checkboxColumn,
    orderNoColumn,
    hawbColumn,
    priorityColumn,
    mawbColumn,
    appointmentsColumn,
    customerNameColumn,
    originDestinationColumn(),
    cityColumn(),
    reference1Column,
    reference2Column,
    routingColumn,
    CreatedByColumn,
    vehicleTypeColumn,
    vehicleImageColumn,
    createdDateColumn,
    approvedDateColumn,
    zipcodeColumn,
    companyNameColumn,
    accountCodeColumn,
    accountNameColumn,
    getAddressColumn("O&D"),
    typeColumn(isCLIEnabled),
    quantityColumn,
    weightColumn,
    statusColumn,
    ageColumn,
    getOrdersLosColumn(),
    zonesColumn,
    accountLimitExceededColumn,
    tagsColumns,
    skidsPallets,
    DeliverByColumn,
    totalDimWeightColumn
  ];

  const legLevelAssignEnabled =
    organizationSettings?.order_assign_without_restriction === "true" ||
    organizationSettings?.order_assign_without_restriction === true;
  if (legLevelAssignEnabled) {
    dispatchCols[0] = getLegWiseRowCheckboxColumn();
    dispatchCols.splice(1, 0, getPickupLegColumnForPreplan(), getDeliveryLegColumnForPreplan());
  }

  if (organizationSettings?.service_level_flow_enabled === "true") {
    dispatchCols.push(getServiceLevelColumn());
  }

  return dispatchCols;
}

const getPrePlanCol = (props) => {
  // destructuring props
  const { 
    showTriggerEdit,
    handleEditOrder,
    refreshCallback,
    showDetailsLink,
    hideAppointmentdate,
    vhTypes,
    organizationSettings = {},
    resolvedAddressCallback,
    navigateToAccount,
    refreshCells,
    showDetailIcon = false,
    setOrderInfo = () => {},
    currentOrgCode,
    orderInfo,
    isMilitaryTime,
    setIsItemVisible,
    accountWeightUnits,
    showStatusColor,
    statusColorContext,
    updateListEstimate = () => { },
    showRecalcForEst = false,
    isCLIEnabled = false,
  } = props;

  const orderNoColumn = getOrderNoPreplanColumn(showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink, null, showStatusColor, statusColorContext, 'preplan');
  const hawbColumn = getHawbColumn(showTriggerEdit, handleEditOrder, refreshCallback, 'preplan');
  const mawbColumn = getMawbColumn(showTriggerEdit, handleEditOrder, refreshCallback, 'preplan');
  const vehicleTypeColumn = getVehicleTypeColumn(vhTypes);
  const vehicleImageColumn = getVehicleImageColumn(vhTypes);
  const zipcodeColumn = getZipcodeColumn(resolvedAddressCallback,"preplan" , setOrderInfo, orderInfo , refreshCells);
  // const companyNameColumn = getCompanyNameColumnForPreplan(navigateToAccount);getCompanyNameColumnsForPreplan
  const companyNamePickupColumns = getPickupColumnForPreplans(navigateToAccount);
  const companyNameDeliveryColumns = getDeliveryColumnForPreplans(navigateToAccount);
  const pickupLegColumn = getPickupLegColumnForPreplan();
  const deliveryLegColumn = getDeliveryLegColumnForPreplan();
  const accountCodeColumn = getAccountCodeColumn(navigateToAccount,"preplan");
  const accountNameColumn = getAccountNameColumn(navigateToAccount,"preplan");
  const customerNameColumn = getCustomerNameColumnForPreplan();
  const reference1Column = getReferenceColumn(showTriggerEdit, handleEditOrder, refreshCallback, 'reference_1');
  const reference2Column = getReferenceColumn(showTriggerEdit, handleEditOrder, refreshCallback, 'reference_2');
  const actionsColumn = getPreplanActionColumn(currentOrgCode);
  const QuantityColumn = getPreplanQuantityColumn(quantityColumn, isMilitaryTime, setIsItemVisible);
  const estimateColumn = estimateBillingColumn(updateListEstimate, showRecalcForEst);
  const tagsColumns = getTagsColumn();
  // const WeightColumnDynamicUnits = getWeightUnitsColumn(weightColumn, "weight", accountWeightUnits);
  const prePlanCols = [
    checkboxColumn,
    orderNoColumn,
    typeColumn(isCLIEnabled),
    hawbColumn,
    mawbColumn,
    cityColumn("preplan"),
    reference1Column,
    reference2Column,
    routingColumn,
    priorityColumn,
    streetColumn("preplan"),
    vehicleTypeColumn,
    vehicleImageColumn,
    customerNameColumn,
    // companyNameColumn,
    accountCodeColumn,
    accountNameColumn,
    // pickupLegColumn,
    // deliveryLegColumn,
    // companyNameColumn,
    companyNamePickupColumns,
    companyNameDeliveryColumns,
    getAddressColumnForPreplan("PREPLAN"),
    getPickupAddressColumnForPreplan(),
    getDeilveryAddressColumnForPreplan(),
    // typeColumn,
    QuantityColumn,
    // WeightColumnDynamicUnits,
    weightColumn,
    skidsPallets,
    age,
    sc("PREPLAN",false,organizationSettings),
    preplanstatusColumn,
    getPreplanLosColumn(),
    zonesColumn,
    zipcodeColumn,
    tagsColumns,
    // actionsColumn
    // preplanOrderActionColumns,
    estimateColumn,
    DeliverByColumn,
    totalDimWeightColumn
  ];

  const legLevelAssignEnabled =
    organizationSettings?.order_assign_without_restriction === "true" ||
    organizationSettings?.order_assign_without_restriction === true;
  if (legLevelAssignEnabled) {
    // Swap row checkbox with tri-state leg-aware checkbox
    prePlanCols[0] = getLegWiseRowCheckboxColumn();
    // Stick Pickup Leg + Delivery Leg right after the checkbox column
    prePlanCols.splice(1, 0, pickupLegColumn, deliveryLegColumn);
    // Strip rowDrag from order/hawb/mawb columns so handle stays only in dedicated column
    orderNoColumn.rowDrag = undefined;
    hawbColumn.rowDrag = undefined;
    mawbColumn.rowDrag = undefined;
  }

  if (legLevelAssignEnabled) {
    // Drag handle lives inside the action column when leg-wise is enabled.
    // Drop original cellRenderer so the cell holds only the drag handle.
    actionsColumn.cellRenderer = null;
    actionsColumn.rowDrag = (params) => !params.data.account_limit_exceeded;
    actionsColumn.rowDragText = (params) => setDragMetaAndGetText(params, "ORDER");
    actionsColumn.cellStyle = { display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: 8 };
  }

  if (organizationSettings?.service_level_flow_enabled === "true") {
    prePlanCols.push(getServiceLevelColumn());
  }

  if (currentOrgCode !== "NETMOVES") {
    prePlanCols.push(actionsColumn);
  }


  return prePlanCols;
}



const getOrderListCols = (props) => {
    // destructuring props
    const {
      showTriggerEdit,

      handleEditOrder,
      refreshCallback,
      showDetailsLink,
      hideAppointmentdate,
      vhTypes,
      organizationSettings,
      resolvedAddressCallback,
      navigateToAccount,
      statusChange,
      handleBillOfRating,
      navigateToRoute,
      generateInvoice,
      handleSurveyDetails,
      currentFilter,
      screen_from,
      moveToPending,
      gotoOrderDetails,
      updateListEstimate,
      accountCodesWithExceededLimit, accountWeightUnits,
      nonBillableAccountCodes,
      showStatusColor,
      statusColorContext,
      warehouseFilter,
      isShipper = false,
      isCLIEnabled = false,
    } = props;
  
    const { currentOrg } = useContext(OrgContext);
  const orderNoColumn = getOrderNoPreplanColumn(showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink, gotoOrderDetails, showStatusColor, statusColorContext);
    const linehaulOrderNoColumn = getLinehaulOrderNumber(gotoOrderDetails);
    // const hawbColumn = getHawbColumn(showTriggerEdit, handleEditOrder, refreshCallback);
  const hawbColumn = getHawbNoColumn(showTriggerEdit, showDetailsLink, handleEditOrder, gotoOrderDetails, statusColorContext, showStatusColor);
  const mawbColumn = getMawbNoColumn(showTriggerEdit, showDetailsLink, handleEditOrder, gotoOrderDetails, statusColorContext, showStatusColor);
    // const mawbColumn = getMawbColumn(showTriggerEdit, handleEditOrder, refreshCallback);
    const reference1Column = getReference1NoColumn(showTriggerEdit,showDetailsLink, handleEditOrder,gotoOrderDetails);
    const reference2Column = getReference2NoColumn(showTriggerEdit,showDetailsLink, handleEditOrder,gotoOrderDetails);
    const appointmentsColumn = getAppointmentsColumn(hideAppointmentdate, organizationSettings, warehouseFilter, refreshCallback, isShipper);
    const windowTimeColumn = getWindowTimeColumn(hideAppointmentdate, organizationSettings);
    const vehicleTypeColumn = getVehicleTypeColumn(vhTypes);

    const vehicleImageColumn = getVehicleImageColumn(vhTypes);
    const zipcodeColumn = setZipcodeColumn(resolvedAddressCallback,refreshCallback);
    const companyNameColumn = getCompanyNameColumn(navigateToAccount);
    const accountCodeColumn = getAccountCodeColumn(navigateToAccount, screen_from, !isShipper);
    const accountNameColumn = getAccountNameColumn(navigateToAccount, screen_from, !isShipper);
    const customerNameColumn = getCustomerNameColumn();
    const ActionColumns = OrdersActionCols(statusChange,handleEditOrder,handleBillOfRating,navigateToRoute,generateInvoice,handleSurveyDetails,currentFilter,screen_from,moveToPending,accountCodesWithExceededLimit, props)
    const estimateColumn  = estimateBillingColumn(updateListEstimate, !isShipper);
    const bolColumn = getSignedBolColumn();
    const tagsColumns = getTagsColumn();
    const hazmatClassCols = getHazmatClassColumn();
    const hazmatDivisionCols = getHazmatDivisionColumn();
    const requiredPlacardColumn = getRequiredPlacardColumn();
  
    const addProperties = (column, isPeculiar, acceptedStatus) => ({
      ...column,
      // floatingFilter: false,
      isPeculiar,
      acceptedStatus, 
      cellStyle: (params) => {        // Get the cell element to measure content width
        const cellElement = params.api.getCellRendererInstances({
          rowIndex: params.node.rowIndex,
          column: params.column
        })[0]?.eGui;
    
        if (cellElement && cellElement.scrollWidth > cellElement.clientWidth) {
          // Apply ellipsis style if content is overflowing
          return ellipsisStyle;
        }
    
        // Return an empty object if no overflow
        return {};
      },
      
    });
  
    const orderCols = [
      addProperties(checkboxColumn, false, []),
      addProperties(orderNoColumn, false, []),
      addProperties({...linehaulOrderNoColumn, sortable: false}, false, []),
      addProperties({...typeColumn(isCLIEnabled), sortable: true},false, []),
      addProperties({...appointmentsColumn, sortable: true},false, []),
      // addProperties({...windowTimeColumn, sortable: false},false, []),
      addProperties({...getAddressColumn("O&D"), sortable: false},false, []),
      addProperties({...pickupAddressColumn, sortable: true},false, []),
      addProperties({...deliveryAddressColumn, sortable: true},false, []),
      addProperties({...originDestinationColumn(organizationSettings), sortable: true},false, []),
      addProperties({...zipcodeColumn, field: 'customer_zipcode', sortable: true},false, []),
      addProperties({...accountCodeColumn, sortable: true},false, []),
      addProperties({...accountNameColumn, sortable: true},false, []),
      addProperties({...ageColumn}, true, ["REJECTED"]),
      addProperties({...receivedDateColumn}, true, ["REJECTED"]),
      addProperties({...receivedAgingColumn}, true, ["REJECTED"]),
      addProperties({...quantityColumn, field: 'quantity', sortable: true},false, []),
      addProperties(getCombinedWeightunits(weightColumn, Number(_.get(props.userContext, "orgRules.org_billing_rules.round_off_decimals","2"))),false, []),
      addProperties(getOrdersLosColumn(), false, []),
      addProperties({...hawbColumn, sortable: true},false, []),
      addProperties({...mawbColumn, sortable: true},false, []),
      addProperties({...reference1Column, sortable: true},false, []),
      addProperties({...reference2Column, sortable: true},false, []),
      addProperties({...statusColumn, sortable: true},false, []),
      addProperties({...ShipperColumn, sortable: true},false, []),
      addProperties({...ConsigneeColumn, sortable: true},false, []),
      addProperties({...routingColumn, sortable: true},false, []),
      addProperties({...sourceColumn, field: 'insertion_type', sortable: true},false, []),
      addProperties({...CreatedByColumn, sortable: true},false, []),
     // addProperties({...vehicleTypeColumn, sortable: false},false, []),
      // addProperties({...vehicleImageColumn, sortable: false},false, []),
      addProperties({...createdDateColumn, sortable: true},false, []),
      addProperties({...approvedDateColumn, sortable: true},false, []),
      addProperties({...companyNameColumn, sortable: true},false, []),
      addProperties(driverColumn(refreshCallback, { sortable: false, organizationSettings, warehouseFilter }),false, []), // ["COMPLETED","DISPATCHED","ASSIGNED",""]
      addProperties({...skidsPallets, sortable: true},false, []),
      addProperties({...exceptionColumn, sortable: false},false, ["EXCEPTION"]),
      addProperties({...onHoldReasonColumn, sortable: false},false, ["ON_HOLD"]),
      // addProperties({...customerNameColumn, field: "customer_first_name" , sortable: true},false, []),
      addProperties({...ActionColumns, sortable: false},false, []),
      addProperties({...estimateColumn, sortable: true},false, []),
      addProperties({...priorityColumn, field: 'priority', sortable: true},false, []),
      addProperties({...DeliverByColumn, field: 'delivery_by' ,sortable: true},false, []),
      addProperties({...CitiesColumn, field: 'customer_city', sortable: true},false, []),
      addProperties({...tagsColumns, sortable: false},false, []),
      addProperties({...itNumberColumn, sortable: true},false, []),
      //addProperties({...zonesColumn, sortable: false},false, []),
      addProperties({...bolColumn, sortable: false},false, []),
      addProperties({...hazmatClassCols, sortable: false},false, []),
      addProperties({...hazmatDivisionCols, sortable: false},false, []),
      addProperties({...requiredPlacardColumn, sortable: false},false, []),
    ];

    if (currentOrg?.code === "NETMOVE") {
      orderCols.push(addProperties(windowTimeColumn, false, []),);
    }

    if (organizationSettings?.ui_version !== "v2") {
      orderCols.push(addProperties({...zonesColumn, sortable: false},false, []));

      orderCols.push(addProperties({...vehicleTypeColumn, sortable: false},false, []));
      orderCols.push(addProperties({...vehicleImageColumn, sortable: false},false, []));
      //orderCols.push(addProperties(driverColumn(refreshCallback, {sortable: false}),false, []));
    }

    if (organizationSettings?.service_level_flow_enabled === "true") {
      orderCols.push(addProperties(getServiceLevelColumn(), false, []));
    }

    return orderCols;
  
  }

const getDeletedOrderListCols = (props) => {
  // destructuring props
  const {
    showTriggerEdit,
    handleEditOrder,
    refreshCallback,
    showDetailsLink,
    navigateToAccount,
    gotoOrderDetails,
  } = props;

  const orderNoColumn = getOrderNoColumn(showTriggerEdit, handleEditOrder, refreshCallback, showDetailsLink, gotoOrderDetails);
  const hawbColumn = getHawbColumn(showTriggerEdit, handleEditOrder, refreshCallback);
  const mawbColumn = getMawbColumn(showTriggerEdit, handleEditOrder, refreshCallback);
  const companyNameColumn = getCompanyNameColumn(navigateToAccount);
  const accountCodeColumn = getAccountCodeColumn(navigateToAccount);
  const accountNameColumn = getAccountNameColumn(navigateToAccount);

  const deletedOrderCols = [
    checkboxColumn,
    orderNoColumn,
    pickupAddressColumn,
    deliveryAddressColumn,
    accountCodeColumn,
    losColumn(),
    hawbColumn,
    mawbColumn,
    reference1Column,
    reference2Column,
    statusColumn,
    companyNameColumn,
  ];

  return deletedOrderCols;
}

const getChartedAccountsCols = (props) => {
  const {handleEditClick,handleDeleteClick} = props;
  const actionChartedAccountsColumns  = getAcctionCols(handleEditClick,handleDeleteClick,false,false)
  const chartedAccountsCols = [
    accountNameColumn,
    accountNo,
    accountDesc,
    actionChartedAccountsColumns
  ]
  return chartedAccountsCols
}


const dateColumn = (lable, field) => {
  return ({
    headerName: lable,
    field: field,
    isVisible : true,
    sortable:false,
    floatingFilter: false,
    valueGetter: (params) => _.get(params, `data.${field}`, '') || '',
    cellRenderer: (params) => {
      const timeString  = _.get(params, `data.${field}`, '') || '';
      return timeString ? 
      <DisplayTime 
      dateTimeString={timeString} 
      timeFormat={AppConfig.dateFormat}
      isUTC={true}/> 
      : ''
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 105,
  });
}
const quoteExpiryDateColumn = (lable, field) => {  
   return ({
    headerName: lable,
    field: field,
    isVisible : true,
    sortable:false,
    floatingFilter: true,
    valueGetter: (params) => {
      const timeString = _.get(params, `data.${field}`, '') || '';
      return timeString ? new Date(timeString).toLocaleDateString() : ''; 
    },
    cellRenderer: (params) => {
      const timeString  = _.get(params, `data.${field}`, '') || '';
      const timeZoneId = _.get(params?.data, 'wh_location_details.time_zone_id', '') || '';
      return timeString ? 
      <DisplayTime 
      dateTimeString={timeString} 
      timeZoneId={timeZoneId}
      timeFormat={AppConfig.dateFormat}/> 
      : ''
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 105,
  });
}
const settlementDateColumn = (lable, field) => {
  return ({
    headerName: lable,
    field: field,
    isVisible : true,
    sortable:false,
    floatingFilter: false,
    valueGetter: (params) => _.get(params, `data.${field}`, '') || '',
    cellRenderer: (params) => {
      const timeString  = _.get(params, `data.${field}`, '') || '';
      return timeString ? 
      <DisplayTime 
      dateTimeString={timeString} 
      timeFormat={AppConfig.dateFormat}/> 
      : ''
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 120,
  });
}
const InvoiceApprovalDateColumn = (lable, field) => {
  return ({
    headerName: lable,
    field: field,
    isVisible : true,
    sortable:false,
    floatingFilter: false,
    valueGetter: (params) => _.get(params, `data.${field}`, '') || '',
    cellRenderer: (params) => {
      const timeString  = _.get(params, `data.${field}`, '') || '';
      return timeString ? 
      <DisplayTime 
      dateTimeString={timeString} 
      timeFormat={AppConfig.dateFormat}/> 
      : ''
    },
    cellStyle: {
      textAlign: 'left',
    },
    width: 150,
  });
}

// const QuoteDateColumn = (lable, field) => {
//   return ({
//     headerName: 'Quote Date',
//     field: 'quote_date',
//     isVisible : true,
//     sortable:false,
//     floatingFilter: false,
//     valueGetter: (params) => _.get(params, `data.${field}`, 'llll') || '',
//     cellRenderer: (params) => {
//       const timeString  = _.get(params, `data.${field}`, 'llll') || '';
//       return timeString ? 
//       <DisplayTime 
//       dateTimeString={timeString} 
//       timeFormat={AppConfig.dateFormat}/> 
//       : ''
//     },
//     cellStyle: {
//       textAlign: 'left',
//     },
//     width: 150,
//   });
// }


const renderDescription = (lable, field) => {
  return{
    headerName: lable,
    field: field,
    isVisible : true,
    sortable: false,
    valueGetter: (params) => _.get(params, `data.${field}`, '') || '',
    cellRenderer: (params) => {
      const content  = _.get(params, `data.${field}`, '') || '';
      return content ? <Tooltip title={content}>{content}</Tooltip> : ''
    },
    cellStyle: {
      textAlign: 'left',
    },
    floatingFilter: false,
    width: 140,
  };
}
 
const getChargeColumn = (decimalPoints, onChange) =>({
  headerName: `Charge (${I18n.t(
    'general.price_symbol'
  )})`,
  field: 'item_charge',
  floatingFilter: false,
  isVisible : true,
  valueGetter: (params) => _.get(params, `data.item_charge`, '') || '',
  cellRenderer: (params) => {
    const content  = _.get(params, `data.item_charge`, '') || '';
    return content ? checkNegitive(content) : "";
  },
  // editable: true,
  // cellEditorFramework: 
  // <CustomInputNumberEditor 
  // value={params.data.charge} 
  // placeholder={I18n.t('reports.chargable')}
  // decimalPoints={decimalPoints}
  // onChange={(e) => {
  //         params.setValue(e); // Update the value in the grid
  //         params.node.setDataValue(params.colDef.field, e); // Update the data
  //       }} />,
  // cellRenderer: (params) => (
  //   <InputNumber
  //     value={params.data.item_charge}
  //     size="small"
  //     className="fontSize12"
  //     // onChange={(e) =>
  //     //   onChange(params.rowIndex, 'charge', e)
  //     // }
  //     onChange={(e) => {
  //       params.setValue(e); // Update the value in the grid
  //       params.node.setDataValue(params.colDef.field, e); // Update the data
  //     }}
  //     placeholder={I18n.t('reports.chargable')}
  //     min={0}
  //     precision={decimalPoints}
  //     style={{ width: 100 }}
  //   />
  // ),
  width: 140,
});

const getSettlementDriver = (props) =>({
  headerName: 'Driver',
  field: 'driver_code',
  isVisible : true,
  cellRenderer: (params) => {
    const updateDriverData = (obj) => {
    //  // params.node.setDataValue('driver_id', obj.driver_id); // Update the data
    //   params.node.setDataValue('driver_code', obj.driver_code);
    //   props.handleUpdateRowData(params.data.id, 'driver_id', obj.driver_id)
      props.fetchData()
    }
    return (
    <div>{ params.data.driver_code } { params.data.type_of_order !== "DEDUCTION" && params.data.status !== 'APPROVED' ? 
    <EditDriverDetails 
      drivers={props.drivers || []}
      defaultDriver={params.data.driver_id}
      currentData={params.data}
      updateDriverData={updateDriverData}
    />
    : ''}</div>
  )},
  floatingFilter: false,
  width: 120,
});

const getDriverSettlemetCols =  (props) => {

  const {navigateToAccount, handleDeleteSettlement, rawDataSource} = props;
const isApprovedIncluded = rawDataSource.some((data) => data.status === "APPROVED");

  const getActionCols = () => {
    const actionCol = {
      headerName: '',
      field: "id",
      sortable: false,
      resizable: false,
      floatingFilter: false,
      pinned: "right",
      width: 90,
      cellRenderer: (params) => (
        <div className='line-actions' style={{ width: '100%' }}>
          <Row type="flex" align="middle">
            { ['MANUAL','DEDUCTION'].includes(params?.data?.type_of_order) && params?.data?.status === 'PENDING' && <Col>
              <Tooltip placement="topLeft" title="Delete">
                <Popconfirm
                  placement="topRight"
                  title={I18n.t('messages.delete_confirm')}
                  onConfirm={() =>
                    handleDeleteSettlement(params.data.id)
                  }
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteIcon styleObj={{ fontSize: 16 }}/>
                  &nbsp;&nbsp;
                </Popconfirm>
              </Tooltip>
            </Col>
            }
          </Row>
        </div >
      )
    
    }
    return actionCol
    }
  const actionColumns  = getActionCols();

  // :customer_order_id, :wh_location_id, :customer_order_number, :hawb, :mawb, :account_id, :account_code, :organization_id, :settlement_date, :gross_revenue, :week_number, 
  // freight_charges: ,:charge_description, :gl_code, :item_id, :item_name, :accessorial_code, :gross_item_value, :item_value, :item_quantity, :item_type, :item_description, :invoice_line_id, 
  // :item_per_cost, :item_quantity, 
  // :location_id, :charge, :eligible, :percentage
  let  decimalPoints = window.localStorage.getItem('round_off_decimals')
  const { endUserName } = useContext(OrgContext);
  decimalPoints =  isEmpty(decimalPoints) ? decimalPoints :  AppConfig.default_decimal_points
  const chargeColumn = getChargeColumn(decimalPoints, props.onChange)
  const driverCol = getSettlementDriver(props)

  const warehouseColumn = {
    headerName: I18n.t('general.warehouse'),
    field: 'wh_name',
    isVisible : true,
    sortable:false,
    valueGetter: (params) => _.get(params, 'data.wh_name', '') || '',
    cellStyle: {
      textAlign: 'left',
    },
    floatingFilter: false,
    width: 120,
  };

  const vehicleTypeColumn = {
    headerName: 'Vehicle Type',
    field: 'vehicle_type',
    isVisible : true,
    sortable:false,
    valueGetter: (params) => _.get(params, 'data.vehicle_type', '') || '',
    cellStyle: {
      textAlign: 'left',
    },
    floatingFilter: false,
    width: 120,
  };

  const companyColumn = {
    headerName: 'Company',
    field: 'company_name',
    isVisible: true,
    sortable: false,
    valueGetter: (params) => _.get(params, 'data.integration_company_code', '') || '',
    cellStyle: {
      textAlign: 'left',
    },
    floatingFilter: false,
    width: 120,
  };

  const endUserColumn = {
    headerName: endUserName,
    field: 'customer_name',
    isVisible : true,
    sortable:false,
    valueGetter: (params) => _.get(params, 'data.consignee_name', '') || '',
    cellStyle: {
      textAlign: 'left',
    },
    floatingFilter: false,
    width: 120,
  };
  const chargeTypeColumn = {
    headerName: 'Charge Type',
    field: 'item_type',
    isVisible : true,
    sortable:false,
    valueGetter: (params) => _.get(params, 'data.item_type', '') || '',
    cellStyle: {
      textAlign: 'left',
    },
    floatingFilter: false,
    
  };
  const statusColumn = {
    headerName: 'Status',
    field: 'status',
    isVisible : true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    sortable: true,
    valueGetter: (params) => _.get(params, 'data.status', '') || '',
    cellStyle: {
      textAlign: 'left',
    },
    floatingFilter: false,
    
  };
  const orderColumn = {
    headerName: I18n.t('order.order_no'),
    field: 'customer_order_number',
    floatingFilter: false,
    isVisible : true,
    cellRenderer: (params) => {
      const { customer_order_id, type_of_order } = params.data;
      return customer_order_id && type_of_order !== "MANUAL" ? (
        <OrderBillingDetails
          record={{ ...params.data }}
          showActions={false}
          handleIsLosChanged={() => {}}
        />
      ) : (
<Fragment><CopyableContent text={params.data.customer_order_number || ''} />
  <sup className="textRed textBold">
    {type_of_order === "MANUAL"
      ? "(M)"
      : type_of_order === "DEDUCTION"
      ? "(D)"
      : ""}
  </sup>
</Fragment>
      );
    },
    width: 110,
  };
  const hawbColumn = {
    headerName: I18n.t('general.hawb'),
    field: 'hawb',
    isVisible : true,
    floatingFilter: false,
    cellRenderer: (params) =>
      params?.data?.hawb ? <CopyableContent text={params.data.hawb || ''} /> : '',
    width: 100,
  };
  const mawbColumn = {
    headerName: I18n.t('general.mawb'),
    field: 'mawb',
    isVisible : true,
    floatingFilter: false,
    cellRenderer: (params) =>
      params?.data?.mawb ? <CopyableContent text={params.data.mawb || ''} /> : '',
    width: 100,
  };
  const eligibleColumn = {
    headerName: `${I18n.t('reports.eligible')}* (${I18n.t(
      'general.price_symbol'
    )})`,
    floatingFilter: false,
    field: 'eligible_charge',
    isVisible : true,
    valueGetter: (params) => _.get(params, `data.eligible_charge`, '') || '',
    cellRenderer: (params) => {
      const content  = _.get(params, `data.eligible_charge`, '') || '';
      return content ? checkNegitive(content) : "";
    },
    // editable: true,
    // cellRenderer: (params) => (
    //     <Input
    //       value={params.data.eligible_charge}
    //       size="small"
    //       className="fontSize12"
    //       // onChange={(e) =>
    //       //   onChange(params.rowIndex, 'charge', e)
    //       // }
    //       onChange={(e) => {
    //         params.setValue(e.target.value); // Update the value in the grid
    //         params.node.setDataValue(params.colDef.field, e.target.value); // Update the data
    //       }}
    //       placeholder={I18n.t('reports.eligible')}
    //       min={0}
    //       precision={decimalPoints}
    //       style={{ width: 100 }}
    //     />
    //   ),
    width: 140,
  };
    const orderGrossAmountColumn = {
    headerName: 'Order Gross Amount',
    field: 'order_gross_amount',
    isVisible : true,
    sortable:false,
    valueGetter: (params) => _.get(params, 'data.order_gross_amount', '') || '',
    cellRenderer: (params) => {
      const content  = _.get(params, 'data.order_gross_amount', '') || '';
      return content ? checkNegitive(content) : "";
    },
    cellStyle: {
      textAlign: 'left',
    },
    floatingFilter: false,
    
  };
  const settlementPercentageColumn = {
    headerName: `${I18n.t('reports.settlement')} %`,
    floatingFilter: false,
    isVisible : true,
    field: 'settlement_percentage',
    // editable: true,
    cellRenderer: (params) => (
      _.get(params, "data.settlement_percentage", '') || ""
    ),
    width: 140,
  };

  const pickupDvAddressColumn = {
    headerName: 'Pickup Address',
    field: 'PickupAddress', 
    isVisible : true,
    floatingFilter: false,
    valueGetter: (params) => getBillingAddress(params.data,'pickup'),
    width: 350, 
    cellStyle: {
      textTransform: 'uppercase',
    },
  };

  const deliveryDvAddressColumn = {
    headerName: "Delivery Address",
    field: "DeliveryAddress",
    isVisible: true,
    floatingFilter: false,
    valueGetter: (params) => getBillingAddress(params.data, "delivery"),
    width: 350,
    cellStyle: {
      textTransform: "uppercase",
    },
  };

  const adjustmentType = {
    headerName: "Adjustment Type",
    field: "AdjustmentType",
    isVisible: true,
    floatingFilter: false,
    valueGetter: (params) => {
     const { customer_order_id, type_of_order } = params.data;
     return customer_order_id && type_of_order !== "MANUAL" ? "AUTO" : type_of_order
    },
    width: 110,
    cellStyle: {
      textTransform: "uppercase",
    },
  };
 
  /* Old setting column where arrow navigartion not working */
 /* const settlementColumn = () => ({
    headerName: `${I18n.t('reports.settlement')} (${I18n.t(
      'general.price_symbol'
    )})`,
    floatingFilter: false,
    isVisible : true,
    field: 'item_value',
    // editable: true,
    cellRenderer: (params) => (
      params.data.status === "PENDING" ? <Input
        value={params.data.item_value}
        size="small"
        className="fontSize12"
        // onChange={(e) =>
        //   onChange(params.rowIndex, 'charge', e)
        // }
        onChange={(e) => {
          if(params.data.type_of_order !== "MANUAL" && parseFloat(e.target.value) < 0){
            alertMessage("Amount should not be lessthan $0.00", 'error')
          } else{
            params.setValue(e.target.value); // Update the value in the grid
            params.node.setDataValue(params.colDef.field, e.target.value); // Update the data
            onChange(params.data.id)
          }
        }}
        onBlur={e => {
            const isExceeds = parseFloat(e.target.value) > parseFloat(params.data.eligible_charge) 
            const value = isExceeds ? params.data.prev_item_value : e.target.value
            if(isExceeds){
              alertMessage(`Amount should not exceeds $` + parseFloat(params.data.eligible_charge), 'error')
              params.setValue(value); // Update the value in the grid
              params.node.setDataValue(params.colDef.field,value); // Update
            }
            if(!isEmpty(params.data.eligible_charge) &&  !isEmpty(value) && parseFloat(params.data.eligible_charge) !== 0){
              const per =  (parseFloat(value) * 100) / parseFloat(params.data.eligible_charge);
              params.node.setDataValue("settlement_percentage", ""+per.toFixed(2) );
            } else {
              params.node.setDataValue("settlement_percentage", "0");
            }
            props.handleUpdateRowData(params.data.id, 'prev_item_value', value)
        }}
        placeholder={I18n.t('reports.settlement')}
        min={0}
        precision={decimalPoints}
        style={{ width: 100 }}
      />
      : 
      checkNegitive(params.data.item_value)
    ),
    width: 140,
  }); */
  const settlementColumn = () => ({
    headerName: `${I18n.t('reports.settlement')} (${I18n.t(
      'general.price_symbol'
    )})`,
    floatingFilter: false,
    isVisible : true,
    field: 'item_value',
    editable: true,
    singleClickEdit: true,
    cellRenderer: (params) => (
      params.data.status === "PENDING" ? 
      <Input
        value={params.data.item_value}
        size="small"
        className="fontSize12"
        onFocus={() => onChange(params.data.id)}

        // onChange={(e) =>
        //   onChange(params.rowIndex, 'charge', e)
        // }
        // onChange={(e) => {
        //   if(params.data.type_of_order !== "MANUAL" && parseFloat(e.target.value) < 0){
        //     alertMessage("Amount should not be lessthan $0.00", 'error')
        //   } else{
        //     params.setValue(e.target.value); // Update the value in the grid
        //     params.node.setDataValue(params.colDef.field, e.target.value); // Update the data
        //     onChange(params.data.id)
        //   }
        // }}
        // onBlur={e => {
        //     const isExceeds = parseFloat(e.target.value) > parseFloat(params.data.eligible_charge) 
        //     const value = isExceeds ? params.data.prev_item_value : e.target.value
        //     if(isExceeds){
        //       alertMessage(`Amount should not exceeds $` + parseFloat(params.data.eligible_charge), 'error')
        //       params.setValue(value); // Update the value in the grid
        //       params.node.setDataValue(params.colDef.field,value); // Update
        //     }
        //     if(!isEmpty(params.data.eligible_charge) &&  !isEmpty(value) && parseFloat(params.data.eligible_charge) !== 0){
        //       const per =  (parseFloat(value) * 100) / parseFloat(params.data.eligible_charge);
        //       params.node.setDataValue("settlement_percentage", ""+per.toFixed(2) );
        //     } else {
        //       params.node.setDataValue("settlement_percentage", "0");
        //     }
        //     props.handleUpdateRowData(params.data.id, 'prev_item_value', value)
        // }}
        placeholder={I18n.t('reports.settlement')}
        min={0}
        precision={decimalPoints}
        style={{ width: 100 }}
      />
      : 
      checkNegitive(params.data.item_value)
    ),
    width: 140,
  });
  // const settlementColumn = () => ({
  //   headerName: `${I18n.t('reports.settlement')} (${I18n.t(
  //     'general.price_symbol'
  //   )})`,
  //   floatingFilter: false,
  //   isVisible : true,
  //   field: 'item_value',
  //   editable: true,
  //   cellEditor: "agNumberCellEditor",
  //   singleClickEdit: true,
  //   cellEditorParams: {
  //     precision: decimalPoints,
  //   },
  //   cellRenderer: (params) => 
  //   <Input 
  //     min={0}
  //     precision={decimalPoints}
  //     style={{ width: 100 }}
  //     value={params.data.item_value ? parseFloat(params.data.item_value) : ''} 
  //   />,
  // });
  
  const percentageColumn = {
    headerName: `Eligibility (%)`,
    floatingFilter: false,
    field: 'eligible_percentage',
    // editable: true,
    isVisible : true,
    cellRenderer: (params) => (
      _.get(params, "data.eligible_percentage", '') || ""
    ),
    width: 120,
  };
  const agentCodeColumn = {
    headerName: `Agent Code`,
    floatingFilter: false,
    field: 'agent_code',
    // editable: true,
    isVisible : true,
    cellRenderer: (params) => (
      _.get(params, "data.agent_code", '') || ""
    ),
    width: 120,
  };
  const { onChange, handleUpdateRowData } = props
  const navigationAccountCode = getAccountCodeColumn(navigateToAccount);
  let listCols = props.viewType === 'SUMMARY' ? [
    renderDescription('Description', 'item_description'),
    renderDescription('Charge Description', 'item_name'),
    chargeTypeColumn,
    chargeColumn,
    percentageColumn,
    eligibleColumn,
    settlementPercentageColumn,
    settlementColumn(onChange, handleUpdateRowData),
  ]:
  [
    orderColumn,
    adjustmentType,
    hawbColumn,
    mawbColumn,
    agentCodeColumn,
    percentageColumn,
    eligibleColumn,
    settlementPercentageColumn,
    settlementColumn(onChange, handleUpdateRowData),
    chargeTypeColumn,
    chargeColumn,
    renderDescription('Charge Description', 'item_name'),
    renderDescription('Description', 'item_description'),
    statusColumn,
    driverCol,
    actionColumns,
    warehouseColumn,
    vehicleTypeColumn,
    {
      ...navigationAccountCode,
      floatingFilter: false,
    }, 
    {...dateColumn(I18n.t('reports.service_date'), 'order_completion_date')},
    {...settlementDateColumn('Settlement Date', 'settlement_date')},
    {...InvoiceApprovalDateColumn('Invoice Approval Date','invoice_approval_date')},
    endUserColumn,
    companyColumn,
    deliveryDvAddressColumn,
    pickupDvAddressColumn,
    orderGrossAmountColumn,
  ];
    listCols.unshift(dvCheckboxColumn);
    
  if(props.status=== "APPROVED"){
    listCols = listCols.filter(col => col.key !== 'checkbox')
  }
  //listCols.push({...settlementDateColumn('Settlement Date', 'settlement_date')});
  
  // if(props.settlementDateColumn){
  //   listCols.push({...settlementDateColumn('Settlement Date', 'settlement_date')});
  // }
  // if(props.showDelete){
  //   listCols.push(actionColumns);
  // }
  //listCols.push(actionColumns);
  return listCols;
};

const getDriverNameColumn = (navigateToAccount) => {
  const companyNameColumn = {
    headerName: 'Company Name',
    field: 'company_name',
    isVisible : true,
    sortable : true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueGetter: (params) => {
      let content;
      if (params.data.type_of_order === "T") {
        const pickupLocation = params.data?.origin;
        const deliveryLocation = params.data?.destination;
        content = formatPickupDeliveryCompanyNames(pickupLocation, deliveryLocation);
      } else {
        content = params.data.company_name;
      }
      return content;
    },
    cellRenderer: (params) => {
      const hasAccess = checkServiceExistance(['OPSAS', 'ACNF'], 'ALL');
      let content;

      if (params.data.type_of_order === "T") {
        content = formatPickupDeliveryCompanyNames(
          params.data?.origin,
          params.data?.destination
        );
      } else {
        content = params.data.company_name;
      }

      return content;
    },
  };
  return companyNameColumn;
};


const getMappedAccountCols = (props) => {
  const { navigateToAccount } = props;
  const accountNameColumn = getAccountNameForMappedAccounts(navigateToAccount);
  const accountCodeColumn = getAccountCodeForMappedAccounts(navigateToAccount);
  const addressColumn = getAddressForMappedAccounts();
  const phoneNumberColumn = getPhoneNumberForMappedAccounts();
  const emailColumn = getEmailForMappedAccounts();
  const contactPersonColumn = getContactPersonForMappedAccounts();

  const dispatchCols = [
    accountNameColumn,
    accountCodeColumn,
    phoneNumberColumn,
    emailColumn,
    contactPersonColumn,
    addressColumn,
  ];
  return dispatchCols;
}




const getPredefinedStopsCols = (props) => {
  const { onEdit, onDelete, organizationSettings = {}, selectedType = "" } = props;

  const { formatByTimeConfig } = require("../../helpers/common");

  // Name column
  const nameColumn = {
    headerName: 'Name',
    field: 'name',
    flex: 1,
    minWidth: 150,
    sortable: true,
  };

  // Code column
  const codeColumn = {
    headerName: 'Code',
    field: 'location_code',
    flex: 1,
    minWidth: 100,
    sortable: true,
  };

  // Type column - uses custom cell renderer for badge styling
  const typeColumn = {
    headerName: 'Type',
    field: 'location_type',
    flex: 1,
    minWidth: 120,
    sortable: true,
    cellRenderer: 'PredefinedStopsTypeCellRenderer',
  };

  // Address column
  const addressColumn = {
    headerName: 'Address',
    field: 'l_address',
    flex: 2,
    minWidth: 300,
    sortable: false,
    valueGetter: (params) => {
      const addr = params.data?.l_address;
      if (!addr) return '-';
      const parts = [
        addr.address_line1,
        addr.address_line2,
        addr.city,
        addr.state,
        addr.zipcode,
        addr.country
      ].filter(Boolean);
      return parts.join(', ');
    },
  };

  // Contact name column
  const contactNameColumn = {
    headerName: 'Contact Name',
    field: 'contact_name',
    flex: 1,
    minWidth: 150,
    sortable: true,
    valueGetter: (params) => {
      const firstName = params.data?.first_name || '';
      const lastName = params.data?.last_name || '';
      return [firstName, lastName].filter(Boolean).join(' ') || '-';
    },
  };

  // Contact phone column
  const contactPhoneColumn = {
    headerName: 'Contact Phone',
    field: 'phone',
    flex: 1,
    minWidth: 120,
    sortable: false,
    valueGetter: (params) => {
      return params.data?.phone || '-';
    },
  };

  // Operational hours column
  const operationalHoursColumn = {
    headerName: 'Operational Hours',
    field: 'operational_hours',
    flex: 1,
    minWidth: 140,
    sortable: false,
    valueGetter: (params) => {
      const startTime = params.data?.start_time;
      const endTime = params.data?.end_time;

      if (!startTime && !endTime) return '-';

      const formatTime = (time) => {
        if (!time) return 'N/A';
        // Check if it's a simple time string (HH:mm or H:mm format) - convert to 12-hour format
        if (typeof time === 'string' && /^\d{1,2}:\d{2}$/.test(time)) {
          const [hours, minutes] = time.split(':');
          const hour = parseInt(hours, 10);
          const ampm = hour >= 12 ? 'PM' : 'AM';
          const hour12 = hour % 12 || 12;
          return `${hour12}:${minutes} ${ampm}`;
        }
        // Handle full datetime strings - always use 12-hour format
        if (moment(time).isValid()) {
          return moment(time).format('hh:mm A');
        }
        return 'N/A';
      };

      const start = formatTime(startTime);
      const end = formatTime(endTime);

      if (start !== 'N/A' || end !== 'N/A') {
        return `${start} - ${end}`;
      }
      return '-';
    },
  };

  // Operational use column (only for drayage-enabled orgs)
  const operationalUseColumn = {
    headerName: 'Operational Use',
    field: 'operational_use',
    flex: 1,
    minWidth: 140,
    sortable: true,
    valueGetter: (params) => {
      const operationalUse = params.data?.operational_use;
      if (!operationalUse) return '-';
      if (operationalUse === "FINAL_MILE") return "Cartage/White Glove";
      if (operationalUse === "DRAYAGE") return "Drayage";
      if (operationalUse === "BOTH") return "Both";
      return operationalUse.replace(/_/g, ' ');
    },
  };

  // Actions column
  const actionsColumn = {
    headerName: '',
    field: 'actions',
    width: 120,
    sortable: false,
    filter: false,
    resizable: false,
    pinned: 'right',
    suppressMenu: true,
    cellRenderer: 'PredefinedStopsActionsCellRenderer',
    cellRendererParams: {
      onEdit,
      onDelete,
    },
    cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  };

  // Build columns array, conditionally include type column
  const columns = [
    nameColumn,
    codeColumn,
  ];


  columns.push(
    addressColumn,
    contactNameColumn,
    contactPhoneColumn,
    operationalHoursColumn,
  );

  const isDrayageEnabled =
    organizationSettings?.drayage_enabled === "true" || organizationSettings?.drayage_enabled === true;
  if (isDrayageEnabled) {
    columns.push(operationalUseColumn);
    columns.push(typeColumn);
  }

  columns.push(actionsColumn);

  return columns;
};

export { getDispatchCols, getPrePlanCol, getOrderListCols, getWarehouseCols, getDriverSettlemetCols, getAccessorialsCols, getQuotesCols, getPendingOrdersCols, getDeletedOrderListCols, getChartedAccountsCols, getMappedAccountCols, getSubOrderCols, getPredefinedStopsCols }
